// // import React, { useState, useEffect, useRef } from "react";
// // import { FaPhone, FaEnvelope, FaComment, FaPen, FaCheck, FaTimes } from "react-icons/fa";
// // import Estimate from "./Estimate/Estimate";
// // import Notes from "./Notes/Notes";
// // import 'react-datepicker/dist/react-datepicker.css';
// // import StatusChange from "./Status/Statuscard";
// // import MoveCostCalculator from "./CostCalculator/Costcalculator";
// // import CallScript from "./CallScript/CallScript";
// // import LongMoveCostCalculator from "./CostCalculator/LongCostcalculator";
// // import SmsEmail from "./SmsEmail/SmsEmail";

// // const LeadDetails = ({ booking: initialBooking, onClose, accessToken, userDetails, userMap, updateLeadData, notes, refetchNotes }) => {
// //   const [booking, setBooking] = useState(initialBooking);
// //   const [isNotesExpanded, setIsNotesExpanded] = useState(false);
// //   const [isStatusExpanded, setIsStatusExpanded] = useState(false);
// //   const [isCostExpanded, setIsCostExpanded] = useState(false);
// //   const [isCallExpanded, setIsCallExpanded] = useState(false);
// //   const [isSmsEmailExpanded, setIsSmsEmailExpanded] = useState(false);
// //   const [moveFromMoveToOptions, setMoveFromMoveToOptions] = useState([]);
// //   const [moveSizeOptions, setMoveSizeOptions] = useState([]);
// //   const [fetchError, setFetchError] = useState(null);
// //   const [moveType, setMoveType] = useState("local"); // default local

// //   const toggleStatus = () => setIsStatusExpanded(!isStatusExpanded);
// //   const toggleCost = () => setIsCostExpanded(!isCostExpanded);
// //   const toggleNotes = () => setIsNotesExpanded(!isNotesExpanded);
// //   const toggleCall = () => setIsCallExpanded(!isCallExpanded);
// //   const toggleSmsEmail = () => setIsSmsEmailExpanded(!isSmsEmailExpanded);
// //   const updateBooking = (fieldKey, newValue, additionalFields = {}) => {
// //     const updatedBooking = {
// //       ...booking,
// //       [fieldKey]: newValue,
// //       ...additionalFields,
// //     };
// //     setBooking(updatedBooking);
// //     updateLeadData(updatedBooking);
// //   };

// //   // Fetch dropdown options from API
// //   useEffect(() => {
// //     const fetchDropdownOptions = async () => {
// //       try {
// //         const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/emailtemp", {
// //           method: "GET",
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${accessToken}`,
// //           },
// //         });
// //         if (!response.ok) {
// //           throw new Error(`HTTP error! Status: ${response.status}`);
// //         }
// //         const data = await response.json();
// //         // console.log("API Response:", JSON.stringify(data, null, 2));

// //         // Extract records array from response
// //         const records = data.records;
// //         if (!Array.isArray(records)) {
// //           throw new Error("API response 'records' is not an array");
// //         }

// //         // Extract unique Move_FromMove_To values
// //         const uniqueMoveFromMoveTo = [...new Set(
// //           records
// //             .filter(item => item.Move_FromMove_To && typeof item.Move_FromMove_To === 'string' && item.Move_FromMove_To.trim() !== '')
// //             .map(item => item.Move_FromMove_To.trim())
// //         )].sort();

// //         // Extract unique MoveSize values
// //         const uniqueMoveSize = [...new Set(
// //           records
// //             .filter(item => item.MoveSize && typeof item.MoveSize === 'string' && item.MoveSize.trim() !== '')
// //             .map(item => item.MoveSize.trim())
// //         )].sort();

// //         // console.log("Processed MoveFromMoveTo Options:", uniqueMoveFromMoveTo);
// //         // console.log("Processed MoveSize Options:", uniqueMoveSize);

// //         setMoveFromMoveToOptions(uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]);
// //         setMoveSizeOptions(uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"]);
// //         setFetchError(null);
// //       } catch (error) {
// //         console.error("Error fetching dropdown options:", error.message);
// //         setFetchError(error.message);
// //         setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
// //         setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
// //       }
// //     };
// //     fetchDropdownOptions();
// //   }, [accessToken]);

// //   const toggleMoveType = () => {
// //     setMoveType((prevType) => (prevType === "local" ? "long" : "local"));
// //   };

// //   return (
// //     <div className="lead-details-lead-details-container">
// //       {fetchError && (
// //         <div style={{ color: "red", marginBottom: "10px" }}>
// //           Error fetching dropdown options: {fetchError}. Using fallback options.
// //         </div>
// //       )}
// //       <div className="lead-header sticky-header">
// //         <div className="lead-header-title" style={{ display: "flex" }}>
// //           <h2>{booking.Customer_Name} - {booking.LeadACVLRecordID}</h2>
// //           <h4 style={{ margin: "0px", marginLeft: "10px", padding: "4px 10px", background: "#ffffff", color: "#000", borderRadius: "10px" }}>
// //             {booking.Lead_Status}
// //           </h4>
// //         </div>
// //         <div className="lead-header-icons">
// //           <a href={`tel:${booking.Phone_Number}`} title="Call"><FaPhone /></a>
// //           <a href={`sms:${booking.Phone_Number}`} title="Message"><FaComment /></a>
// //           <a href={`mailto:${booking.Email}`} title="Email"><FaEnvelope /></a>
// //           <button onClick={onClose}>×</button>
// //         </div>
// //       </div>

// //       <div className="lead-content">
// //         <Estimate accessToken={accessToken} booking={booking} userDetails={userDetails} userMap={userMap} updateLeadData={updateLeadData} />
        
// //         <div className="mt-4">
// //           {sections.map((section, index) => (
// //             <Section
// //               key={index}
// //               title={section.title}
// //               fields={section.fields}
// //               booking={booking}
// //               accessToken={accessToken}
// //               userMap={userMap}
// //               userDetails={userDetails}
// //               updateBooking={updateBooking}
// //               moveFromMoveToOptions={moveFromMoveToOptions}
// //               moveSizeOptions={moveSizeOptions}
// //             />
// //           ))}
// //         </div>

// //         <div className="status-section">
// //           <div className="lead-section-header" onClick={toggleStatus} style={{ cursor: "pointer" }}>
// //             <h2 className="lead-section-title">
// //               Status Change
// //               <button onClick={(e) => { e.stopPropagation(); toggleStatus(); }}></button>
// //             </h2>
// //           </div>
// //           {isStatusExpanded && (
// //             <StatusChange
// //               booking={booking}
// //               updateBooking={updateBooking}
// //               accessToken={accessToken}
// //               userMap={userMap}
// //               userDetails={userDetails}
// //             />
// //           )}
// //         </div>

// //         <div className="notes-section">
// //           <div className="lead-section-header" onClick={toggleNotes} style={{ cursor: "pointer" }}>
// //             <h2 className="lead-section-title">
// //               Notes
// //               <button onClick={(e) => { e.stopPropagation(); toggleNotes(); }}></button>
// //             </h2>
// //           </div>
// //           {isNotesExpanded && <Notes 
// //                                 notes={notes} 
// //                                 refetchNotes={refetchNotes} 
// //                                 accessToken={accessToken} 
// //                                 LeadId={booking.LeadACVLRecordID} 
// //                                 userDetails={userDetails} 
// //                                 updateLeadData={updateLeadData}
// //                                 rowId={booking.ROWID} 
// //                                 />}
// //         </div>

// //         {/* <div className="status-section">
// //           <div className="lead-section-header" onClick={toggleCost} style={{ cursor: "pointer",marginTop:"10px" }}>
// //             <h2 className="lead-section-title">
// //               Cost Calculator
// //               <button onClick={(e) => { e.stopPropagation(); toggleCost(); }}></button>
// //             </h2>
// //           </div>
// //           {isCostExpanded && (
// //             <MoveCostCalculator
// //               booking={booking}
// //               updateBooking={updateBooking}
// //               accessToken={accessToken}
// //               userMap={userMap}
// //               userDetails={userDetails}
// //             />
// //           )}
// //         </div> */}

// //         <div className="status-section">
// //         <div
// //           className="lead-section-header"
// //           onClick={toggleCost}
// //           style={{
// //             cursor: "pointer",
// //             marginTop: "10px",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "space-between"
// //           }}
// //         >
// //           <h2 className="lead-section-title" style={{ margin: 0 }}>
// //             {moveType === "local" ? "Local Distance Move Cost Calculator" : "Long Distance Move Cost Calculator"}
// //           </h2>

// //           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
// //             <button
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 toggleMoveType();
// //               }}
// //               style={{
// //                 padding: "4px 10px",
// //                 borderRadius: "6px",
// //                 border: "1px solid #ccc",
// //                 cursor: "pointer",
// //                 background: "#fff",
// //                 fontSize: "14px"
// //               }}
// //             >
// //               {moveType === "local" ? "Switch to Long Move" : "Switch to Local Move"}
// //             </button>
// //           </div>
// //         </div>

// //         {isCostExpanded && (
// //           <>
// //             {moveType === "local" ? (
// //               <MoveCostCalculator
// //                 booking={booking}
// //                 updateBooking={updateBooking}
// //                 accessToken={accessToken}
// //                 userMap={userMap}
// //                 userDetails={userDetails}
// //               />
// //             ) : (
// //               <LongMoveCostCalculator
// //                 booking={booking}
// //                 updateBooking={updateBooking}
// //                 accessToken={accessToken}
// //                 userMap={userMap}
// //                 userDetails={userDetails}
// //               />
// //             )}
// //           </>
// //         )}
// //         </div>

// //         <div className="status-section">
// //           <div className="lead-section-header" onClick={toggleCall} style={{ cursor: "pointer",marginTop:"10px" }}>
// //             <h2 className="lead-section-title">
// //               Call Script - Terms & Conditions
// //               <button onClick={(e) => { e.stopPropagation(); toggleCall(); }}></button>
// //             </h2>
// //           </div>
// //           {isCallExpanded && (
// //             <CallScript accessToken={accessToken} />
// //           )}
// //         </div>

// //         <div className="status-section">
// //           <div className="lead-section-header" onClick={toggleSmsEmail} style={{ cursor: "pointer",marginTop:"10px" }}>
// //             <h2 className="lead-section-title">
// //               SMS/Email 
// //               <button onClick={(e) => { e.stopPropagation(); toggleSmsEmail(); }}></button>
// //             </h2>
// //           </div>
// //           {isSmsEmailExpanded && (
// //             <SmsEmail accessToken={accessToken} LeadACVLRecordID={booking.LeadACVLRecordID} />
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // const Section = ({ title, fields, booking, accessToken, userMap, userDetails, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
// //   const [isExpanded, setIsExpanded] = useState(false);
// //   const toggleExpand = () => setIsExpanded(!isExpanded);

// //   const isLeadInfoSection = title === "Lead Information";
// //   const hasDuplicateDetails = booking && booking.Duplicate_Lead_Details && booking.Duplicate_Lead_Details.trim() !== "";
// //   const isReturnStatus = booking && booking.Lead_Source_Status === "Return";

// //   let updatedFields = [...fields];

// //   if (isLeadInfoSection) {
// //     const returnFields = [
// //       { label: "Return Category", key: "Return_Category" },
// //       { label: "Return Outcome", key: "Return_Outcome" },
// //       { label: "Return Reason Provide", key: "Return_Reason_Provide" },
// //       { label: "Return Outcome Reason", key: "Return_Outcome_Reason" },
// //     ];

// //     const leadSourceStatusIndex = fields.findIndex(field => field.key === "Lead_Source_Status");

// //     updatedFields.push({ label: "Duplicate Lead Details", key: "Duplicate_Lead_Details" });

// //     if (isReturnStatus && leadSourceStatusIndex !== -1) {
// //       updatedFields.splice(leadSourceStatusIndex + 2, 0, ...returnFields);
// //     }
// //   }

// //   const headerStyle = {
// //     cursor: "pointer",
// //     background: isLeadInfoSection && hasDuplicateDetails ? "#FF0000" : "#4169E1",
// //     padding: "15px 20px",
// //     borderRadius: "8px",
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     width: "100%",
// //     boxSizing: "border-box",
// //     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
// //     animation: "EstimateFadeIn 0.5s ease-in-out",
// //     height: "60px",
// //   };

// //   const getHrStyle = (key) => {
// //     if (key === "Lead_Source_Status") {
// //       return { margin: "62px 0px 10px 0", width: "110%", background: "black" };
// //     } else if (key === "Duplicate_Lead_Details") {
// //       return { margin: "19.5px 0", width: "100%", background: "black" };
// //     }
// //     return {};
// //   };

// //   return (
// //     <div className="lead-section">
// //       <div className="lead-section-header" style={headerStyle} onClick={toggleExpand}>
// //         <h2 className="lead-section-title">
// //           {title}
// //           <button onClick={(e) => { e.stopPropagation(); toggleExpand(); }}></button>
// //         </h2>
// //       </div>
// //       {isExpanded && (
// //         <div className="lead-section-content">
// //           {updatedFields.map((field, index) => {
// //             if (field.isPlaceholder) {
// //               return <div key={index} style={{ visibility: "hidden" }}></div>;
// //             }

// //             const shouldShowHr = isLeadInfoSection && isReturnStatus &&
// //               (field.key === "Lead_Source_Status" || field.key === "Duplicate_Lead_Details");

// //             return (
// //               <div key={index}>
// //                 <EditableField
// //                   label={field.label}
// //                   value={booking[field.key]}
// //                   rowId={booking.ROWID}
// //                   fieldKey={field.key}
// //                   accessToken={accessToken}
// //                   userMap={userMap}
// //                   userDetails={userDetails}
// //                   booking={booking}
// //                   updateBooking={updateBooking}
// //                   moveFromMoveToOptions={moveFromMoveToOptions}
// //                   moveSizeOptions={moveSizeOptions}
// //                 />
// //                 {shouldShowHr && <hr style={getHrStyle(field.key)} />}
// //               </div>
// //             );
// //           })}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // const EditableField = ({ label, value, rowId, fieldKey, accessToken, userMap, userDetails, booking, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
// //   const [isEditing, setIsEditing] = useState(false);
// //   const [currentValue, setCurrentValue] = useState(value);
// //   const [tempValue, setTempValue] = useState(value);
// //   const [showEditIcon, setShowEditIcon] = useState(false);
// //   const [errorMessage, setErrorMessage] = useState("");
// //   const [showDropdown, setShowDropdown] = useState(false);
// //   const [filteredOptions, setFilteredOptions] = useState(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
// //   const [highlightedIndex, setHighlightedIndex] = useState(-1);
// //   const inputRef = useRef(null);
// //   const dropdownRef = useRef(null);

// //   const [returnFields, setReturnFields] = useState({
// //     Return_Category: booking.Return_Category || "",
// //     Return_Reason_Provide: booking.Return_Reason_Provide || "",
// //     Return_Outcome: booking.Return_Outcome || "",
// //     Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
// //   });

// //   const returnCategoryOptions = [
// //     "Returned - Already Moved",
// //     "Returned - Duplicate",
// //     "Returned - Invalid",
// //     "Returned - Need only Estimate",
// //     "Returned - No Budget",
// //     "Returned - Test Lead",
// //     "Returned - Wrong Number",
// //   ];

// //   const returnOutcomeOptions = [
// //     "Approved",
// //     "Rejected",
// //   ];

// //   useEffect(() => {
// //     setCurrentValue(value);
// //     setTempValue(value || "");
// //     setIsEditing(false);
// //     setErrorMessage("");
// //     setShowDropdown(false);
// //     setFilteredOptions(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
// //     setHighlightedIndex(-1);
// //     setReturnFields({
// //       Return_Category: booking.Return_Category || "",
// //       Return_Reason_Provide: booking.Return_Reason_Provide || "",
// //       Return_Outcome: booking.Return_Outcome || "",
// //       Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
// //     });
// //   }, [value, booking, moveFromMoveToOptions, moveSizeOptions, fieldKey]);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
// //         setShowDropdown(false);
// //         setHighlightedIndex(-1);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   const nonEditableFields = [
// //     "LeadACVLRecordID",
// //     "Received_Time_IST",
// //     "Received_Date_EST",
// //     "Banner",
// //     "LeadProviderLeadId",
// //     "Lead_Status",
// //     // "Lead_Source",
// //     "Lead_Priority",
// //     "Duplicate",
// //     "Duplicate_Lead_Details",
// //   ];
// //   const isReadOnly = nonEditableFields.includes(fieldKey);

// //   const userOptions = Object.entries(userMap).map(([userId, userName]) => ({
// //     id: userId,
// //     name: userName,
// //   }));

// //   const validateCityFormat = (input) => {
// //     const cityFormatRegex = /^[A-Za-z\s\-.']+,\s[A-Z]{2}$/;
// //     return cityFormatRegex.test(input);
// //   };

// //   const handleInputChange = (e) => {
// //     const input = e.target.value;
// //     setTempValue(input);
// //     setErrorMessage("");

// //     if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
// //       const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
// //       if (input.trim() === "") {
// //         setFilteredOptions(options);
// //         setShowDropdown(true);
// //       } else {
// //         const filtered = options.filter(option =>
// //           option.toLowerCase().startsWith(input.toLowerCase())
// //         );
// //         setFilteredOptions(filtered);
// //         setShowDropdown(true);
// //       }
// //       setHighlightedIndex(-1);
// //     }
// //   };

// //   const handleOptionSelect = (option) => {
// //     setTempValue(option);
// //     setShowDropdown(false);
// //     setHighlightedIndex(-1);
// //     if (inputRef.current) {
// //       inputRef.current.focus();
// //     }
// //   };

// //   const handleInputFocus = () => {
// //     if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
// //       setShowDropdown(true);
// //       const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
// //       setFilteredOptions(tempValue ? options.filter(option =>
// //         option.toLowerCase().startsWith(tempValue.toLowerCase())
// //       ) : options);
// //     }
// //   };

// //   const handleKeyDown = (e) => {
// //     if (!["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey) || !showDropdown) return;

// //     if (e.key === "ArrowDown") {
// //       e.preventDefault();
// //       setHighlightedIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : 0));
// //     } else if (e.key === "ArrowUp") {
// //       e.preventDefault();
// //       setHighlightedIndex(prev => (prev > 0 ? prev - 1 : filteredOptions.length - 1));
// //     } else if (e.key === "Enter" && highlightedIndex >= 0) {
// //       e.preventDefault();
// //       handleOptionSelect(filteredOptions[highlightedIndex]);
// //     } else if (e.key === "Escape") {
// //       setShowDropdown(false);
// //       setHighlightedIndex(-1);
// //     }
// //   };

// //   const handleSave = async () => {
// //     if (isReadOnly) return;

// //     // Validate city format for OriginCity and DestinationCity
// //     if (["OriginCity", "DestinationCity"].includes(fieldKey) && tempValue && !validateCityFormat(tempValue)) {
// //       setErrorMessage("Please enter the city in the format 'City name, XX' (e.g., 'Toronto, ON')");
// //       return;
// //     }

// //     // Validate Move_Size (only check for non-empty)
// //     if (fieldKey === "Move_Size" && !tempValue.trim()) {
// //       setErrorMessage("Please enter a move size");
// //       return;
// //     }

// //     const previousBooking = { ...booking };
// //     let updatedData = [{ ROWID: rowId, [fieldKey]: tempValue }];
// //     let additionalFields = {};

// //     if (fieldKey === "AssignedUserID") {
// //       const selectedUser = userOptions.find((user) => user.id === tempValue);
// //       if (selectedUser) {
// //         updatedData[0].Sales_Agent = selectedUser.name;
// //         additionalFields.Sales_Agent = selectedUser.name;
// //       }
// //     } else if (fieldKey === "Lead_Source_Status" && tempValue === "Return") {
// //       updatedData[0] = {
// //         ...updatedData[0],
// //         Return_Category: returnFields.Return_Category,
// //         Return_Reason_Provide: returnFields.Return_Reason_Provide,
// //         Return_Outcome: returnFields.Return_Outcome,
// //         Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
// //       };
// //       additionalFields = {
// //         ...additionalFields,
// //         Return_Category: returnFields.Return_Category,
// //         Return_Reason_Provide: returnFields.Return_Reason_Provide,
// //         Return_Outcome: returnFields.Return_Outcome,
// //         Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
// //       };
// //     } else if (fieldKey === "Lead_Source_Status" && tempValue === "Valid") {
// //       updatedData[0] = {
// //         ...updatedData[0],
// //         Return_Category: "",
// //         Return_Reason_Provide: "",
// //         Return_Outcome: "",
// //         Return_Outcome_Reason: "",
// //       };
// //       additionalFields = {
// //         ...additionalFields,
// //         Return_Category: "",
// //         Return_Reason_Provide: "",
// //         Return_Outcome: "",
// //         Return_Outcome_Reason: "",
// //       };
// //     } else if (["Return_Category", "Return_Reason_Provide", "Return_Outcome", "Return_Outcome_Reason"].includes(fieldKey)) {
// //       updatedData[0] = {
// //         ...updatedData[0],
// //         [fieldKey]: tempValue,
// //       };
// //       additionalFields = {
// //         ...additionalFields,
// //         [fieldKey]: tempValue,
// //       };
// //     } else {
// //       if (!booking.AssignedUserID) {
// //         updatedData[0].AssignedUserID = userDetails.userId;
// //         const defaultUser = userOptions.find((user) => user.id === userDetails.userId);
// //         if (defaultUser) {
// //           updatedData[0].Sales_Agent = defaultUser.name;
// //           additionalFields.AssignedUserID = userDetails.userId;
// //           additionalFields.Sales_Agent = defaultUser.name;
// //         }
// //       }
// //     }
// //     console.log (updatedData);
// //     try {
// //       updateBooking(fieldKey, tempValue, additionalFields);
// //       const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/leadsdata", {
// //         method: "PUT",
// //         headers: {
// //           "Content-Type": "application/json",
// //           Authorization: `Bearer ${accessToken}`,
// //         },
// //         body: JSON.stringify(updatedData),
// //       });

// //       if (!response.ok) {
// //         throw new Error("Failed to save data");
// //       }

// //       // console.log("Save successful, updated booking:", booking);
// //       setCurrentValue(tempValue);
// //       setIsEditing(false);
// //       setErrorMessage("");
// //       setShowDropdown(false);
// //     } catch (error) {
// //       console.error("Error updating field", error);
// //       updateBooking(fieldKey, previousBooking[fieldKey], {
// //         Sales_Agent: previousBooking.Sales_Agent,
// //         AssignedUserID: previousBooking.AssignedUserID,
// //         Return_Category: previousBooking.Return_Category,
// //         Return_Reason_Provide: previousBooking.Return_Reason_Provide,
// //         Return_Outcome: previousBooking.Return_Outcome,
// //         Return_Outcome_Reason: previousBooking.Return_Outcome_Reason,
// //       });
// //       setTempValue(currentValue);
// //       setReturnFields({
// //         Return_Category: previousBooking.Return_Category || "",
// //         Return_Reason_Provide: previousBooking.Return_Reason_Provide || "",
// //         Return_Outcome: previousBooking.Return_Outcome || "",
// //         Return_Outcome_Reason: previousBooking.Return_Outcome_Reason || "",
// //       });
// //       setErrorMessage("Failed to save changes. Please try again.");
// //     }
// //   };

// //   const handleCancel = () => {
// //     setTempValue(currentValue);
// //     setReturnFields({
// //       Return_Category: booking.Return_Category || "",
// //       Return_Reason_Provide: booking.Return_Reason_Provide || "",
// //       Return_Outcome: booking.Return_Outcome || "",
// //       Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
// //     });
// //     setIsEditing(false);
// //     setErrorMessage("");
// //     setShowDropdown(false);
// //     setHighlightedIndex(-1);
// //   };

// //   const handleInputClick = () => {
// //     if (!isReadOnly) {
// //       setIsEditing(true);
// //       setShowDropdown(["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey));
// //     }
// //   };

// //   if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
// //     // console.log(`Rendering ${fieldKey} with tempValue:`, tempValue);
// //     // console.log(`Rendering ${fieldKey} with moveFromMoveToOptions:`, moveFromMoveToOptions);
// //     // console.log(`Rendering ${fieldKey} with moveSizeOptions:`, moveSizeOptions);
// //     // console.log(`Rendering ${fieldKey} with filteredOptions:`, filteredOptions);
// //   }

// //   return (
// //     <div className="editable-field" onMouseEnter={() => setShowEditIcon(true)} onMouseLeave={() => setShowEditIcon(false)}>
// //       <label>{label}</label>
// //       {errorMessage && (
// //         <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
// //           {errorMessage}
// //         </div>
// //       )}
// //       <div className="input-container" style={{ display: "flex", alignItems: "center" }}>
// //         {fieldKey === "AssignedUserID" ? (
// //           isEditing ? (
// //             <select value={tempValue || ""} onChange={e => setTempValue(e.target.value)} className="editable-input" style={{ width: "100%", padding: "8px" }}>
// //               <option value="">Select User</option>
// //               {userOptions.map((user) => (
// //                 <option key={user.id} value={user.id}>
// //                   {user.name}
// //                 </option>
// //               ))}
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={userMap[currentValue] || "Select User"}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "Move_Date"  || fieldKey === "DeliveryDate" ? (
// //           isEditing ? (
// //             <input
// //               type="date"
// //               style={{ width: "80%", padding: "8px" }}
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               autoFocus
// //             />
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "Duplicate_Lead_Details" ? (
// //           <textarea
// //             value={tempValue || ""}
// //             readOnly
// //             className="read-only-input"
// //             style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
// //           />
// //         ) : fieldKey === "Return_Reason_Provide" || fieldKey === "Return_Outcome_Reason" 
// //         || fieldKey === "ToolsRequired" || fieldKey === "PackingSupplies" || fieldKey === "Inventory_List" ? (
// //           isEditing ? (
// //             <textarea
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
// //             />
// //           ) : (
// //             <textarea
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "Return_Category" ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Return Category</option>
// //               {returnCategoryOptions.map((option) => (
// //                 <option key={option} value={option}>
// //                   {option}
// //                 </option>
// //               ))}
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "Lead_Source_Status" ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Status</option>
// //               <option value="Valid">Valid</option>
// //               <option value="Return">Return</option>
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "OriginPropertyType" || fieldKey === "DestinationPropertyType" ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Status</option>
// //               <option value="Apartment">Apartment</option>
// //               <option value="Condo">Condo</option>
// //               <option value="Townhouse">Townhouse</option>
// //               <option value="House">House</option>
// //               <option value="Storage">Storage</option>
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ): fieldKey === "Return_Outcome" ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Return Outcome</option>
// //               {returnOutcomeOptions.map((option) => (
// //                 <option key={option} value={option}>
// //                   {option}
// //                 </option>
// //               ))}
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ): fieldKey === "FlexibleDeliveryDate" || fieldKey === "NeedPackingServices"
// //         || fieldKey === "ParkingAvailableAtOrigin" || fieldKey === "HeavyEquipments"
// //         || fieldKey === "ParkingAvailableAtDestination" || fieldKey === "ServiceElevatoratOrigin"
// //         || fieldKey === "ServiceElevatoratDestination" ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Option</option>
// //               <option value="No">No</option>
// //               <option value="Yes">Yes</option>
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ): fieldKey === "DismantlingOfFurnitures"  ? (
// //           isEditing ? (
// //             <select
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             >
// //               <option value="">Select Option</option>
// //               <option value="Required">Required</option>
// //               <option value="Not required">Not required</option>
// //             </select>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "LongWalkAtDestination" || fieldKey === "LongWalkAtOrigin"  ? (
// //           isEditing ? (
// //             <input
// //               type="number"
// //               value={tempValue || ""}
// //               placeholder="Long walks in Yaurds"
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           ) : (
// //             <input
// //               type="number"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "NoOfStaircasesAtDestination" || fieldKey === "NoOfStaircasesAtOrigin" ? (
// //           isEditing ? (
// //             <input
// //               type="number"
// //               value={tempValue || ""}
// //               placeholder="Enter the count of staircases"
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           ) : (
// //             <input
// //               type="number"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : fieldKey === "OriginCity" || fieldKey === "DestinationCity" || fieldKey === "Move_Size" ? (
// //           isEditing ? (
// //             <div style={{ position: "relative", width: "100%" }}>
// //               <input
// //                 type="text"
// //                 ref={inputRef}
// //                 value={tempValue || ""}
// //                 onChange={handleInputChange}
// //                 onFocus={handleInputFocus}
// //                 onKeyDown={handleKeyDown}
// //                 className="editable-input"
// //                 style={{ width: "100%", padding: "8px", minHeight: "34px" }}
// //                 placeholder={fieldKey === "Move_Size" ? "Enter or select move size (e.g., 2 Bedroom)" : "Enter or select city (e.g., Toronto, ON)"}
// //                 autoFocus
// //               />
// //               {showDropdown && filteredOptions.length > 0 && (
// //                 <ul
// //                   ref={dropdownRef}
// //                   style={{
// //                     position: "absolute",
// //                     top: "100%",
// //                     left: 0,
// //                     right: 0,
// //                     background: "#fff",
// //                     border: "1px solid #ccc",
// //                     borderRadius: "4px",
// //                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
// //                     maxHeight: "200px",
// //                     overflowY: "auto",
// //                     listStyle: "none",
// //                     padding: 0,
// //                     margin: 0,
// //                     zIndex: 1000,
// //                   }}
// //                 >
// //                   {filteredOptions.map((option, index) => (
// //                     <li
// //                       key={option}
// //                       onClick={() => handleOptionSelect(option)}
// //                       onMouseEnter={() => setHighlightedIndex(index)}
// //                       style={{
// //                         padding: "8px",
// //                         cursor: "pointer",
// //                         background: highlightedIndex === index ? "#f0f0f0" : "transparent",
// //                       }}
// //                     >
// //                       {option}
// //                     </li>
// //                   ))}
// //                 </ul>
// //               )}
// //             </div>
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         ) : (
// //           isEditing ? (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               onChange={e => setTempValue(e.target.value)}
// //               className="editable-input"
// //               style={{ width: "100%", padding: "8px" }}
// //               autoFocus
// //             />
// //           ) : (
// //             <input
// //               type="text"
// //               value={tempValue || ""}
// //               readOnly
// //               onClick={handleInputClick}
// //               className={isReadOnly ? "read-only-input" : "editable-input"}
// //               style={{ width: "100%", padding: "8px" }}
// //             />
// //           )
// //         )}
// //         {!isReadOnly && isEditing ? (
// //           <div className="edit-icons" style={{ marginLeft: "10px" }}>
// //             <FaCheck onClick={handleSave} className="save-icon" />
// //             <FaTimes onClick={handleCancel} className="cancel-icon" />
// //           </div>
// //         ) : (
// //           !isReadOnly && showEditIcon && <FaPen className="edit-icon" onClick={() => setIsEditing(true)} style={{ marginLeft: "10px" }} />
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // const sections = [
// //   {
// //     title: "Lead Information",
// //     fields: [
// //       { label: "Sales Agent", key: "AssignedUserID" },
// //       { label: "Move Type", key: "Move_Type" },
// //       { label: "ACVL LeadID", key: "LeadACVLRecordID" },
// //       { label: "Received Date IST", key: "Received_Time_IST" },
// //       { label: "Received Date EST", key: "Received_Date_EST" },
// //       { label: "Banner", key: "Banner" },
// //       { label: "Lead Priority", key: "Lead_Priority" },
// //       { label: "Lead Source ID", key: "LeadProviderLeadId" },
// //       { label: "Lead Source Status", key: "Lead_Source_Status" },
// //     ],
// //   },
// //   {
// //     title: "Customer Information",
// //     fields: [
// //       { label: "Customer Name", key: "Customer_Name" },
// //       { label: "Phone Number", key: "Phone_Number" },
// //       { label: "Alternate Phone Number", key: "Alt_Phone_Number" },
// //       { label: "Email", key: "Email" },
// //     ],
// //   },
// //   {
// //     title: "Move Details",
// //     fields: [
// //       { label: "Move Size", key: "Move_Size" },
// //       { label: "Move Date", key: "Move_Date" },
// //       { label: "Delivery Date", key: "DeliveryDate" },
// //       { label: "Flexible for Delivery Date", key: "FlexibleDeliveryDate" },
// //       { label: "From Province", key: "OriginCity" },
// //       { label: "To Province", key: "DestinationCity" },
// //       { label: "From Address", key: "FromAddress" },
// //       { label: "To Address", key: "ToAddress" },
// //       { label: "From PostCode", key: "FromPostCode" },
// //       { label: "To PostCode", key: "ToPostCode" },
// //       { label: "Origin property type", key: "OriginPropertyType" },
// //       { label: "Destination property type", key: "DestinationPropertyType" },
// //       { label: "No of staircases at origin", key: "NoOfStaircasesAtOrigin" }, 
// //       { label: "No of staircases at destination", key: "NoOfStaircasesAtDestination" }, 
// //       { label: "Which floor at origin", key: "WithFloorAtOrigin" }, 
// //       { label: "Which floor at destination", key: "WithFloorAtDestination" }, 
// //       { label: "Elevator availability at origin", key: "ServiceElevatoratOrigin" },
// //       { label: "Elevator availability at destination", key: "ServiceElevatoratDestination" },
// //       { label: "Long walk at origin", key: "LongWalkAtOrigin" },
// //       { label: "Long walk at destination", key: "LongWalkAtDestination" },
// //       { label: "Parking available at origin", key: "ParkingAvailableAtOrigin" },
// //       { label: "Parking available at destination", key: "ParkingAvailableAtDestination" },
// //       { label: "Heavy equipments", key: "HeavyEquipments" },
// //       { label: "Need packing services", key: "NeedPackingServices" }, 
// //       { label: "Dismantling of furnitures", key: "DismantlingOfFurnitures" },
// //       { label: "Tools required to complete the Move", key: "ToolsRequired" }, 
// //       { label: "Packing supplies", key: "PackingSupplies" }, 
// //       { label: "Inventory List", key: "Inventory_List" }, 
// //     ],
// //   },
// // ];

// // export default LeadDetails;


// // after getting dropdown

// import React, { useState, useEffect, useRef } from "react";
// import { FaPhone, FaEnvelope, FaComment, FaPen, FaCheck, FaTimes } from "react-icons/fa";
// import Estimate from "./Estimate/Estimate";
// import Notes from "./Notes/Notes";
// import 'react-datepicker/dist/react-datepicker.css';
// import StatusChange from "./Status/Statuscard";
// import MoveCostCalculator from "./CostCalculator/Costcalculator";
// import CallScript from "./CallScript/CallScript";
// import LongMoveCostCalculator from "./CostCalculator/LongCostcalculator";
// import SmsEmail from "./SmsEmail/SmsEmail";

// let cachedMoveFromMoveToOptions = null;
// let cachedMoveSizeOptions = null;

// const LeadDetails = ({ booking: initialBooking, onClose, accessToken, userDetails, userMap, updateLeadData, notes, refetchNotes }) => {
//   const [booking, setBooking] = useState(initialBooking);
//   const [isNotesExpanded, setIsNotesExpanded] = useState(false);
//   const [isStatusExpanded, setIsStatusExpanded] = useState(false);
//   const [isCostExpanded, setIsCostExpanded] = useState(false);
//   const [isCallExpanded, setIsCallExpanded] = useState(false);
//   const [isSmsEmailExpanded, setIsSmsEmailExpanded] = useState(false);
//   const [smsEmailMode, setSmsEmailMode] = useState('sms');
//   const [moveFromMoveToOptions, setMoveFromMoveToOptions] = useState([]);
//   const [moveSizeOptions, setMoveSizeOptions] = useState([]);
//   const [fetchError, setFetchError] = useState(null);
//   const [moveType, setMoveType] = useState("local"); // default local

//   const toggleStatus = () => setIsStatusExpanded(!isStatusExpanded);
//   const toggleCost = () => setIsCostExpanded(!isCostExpanded);
//   const toggleNotes = () => setIsNotesExpanded(!isNotesExpanded);
//   const toggleCall = () => setIsCallExpanded(!isCallExpanded);
  
//   const toggleSmsEmail = () => {
//     if (isSmsEmailExpanded) {
//       setIsSmsEmailExpanded(false);
//     } else {
//       setSmsEmailMode('sms');
//       setIsSmsEmailExpanded(true);
//     }
//   };
//   const handleMessageClick = () => {
//     setSmsEmailMode('sms');
//     setIsSmsEmailExpanded(true);
//   };
//   const handleEmailClick = () => {
//     setSmsEmailMode('email');
//     setIsSmsEmailExpanded(true);
//   };

//   const updateBooking = (fieldKey, newValue, additionalFields = {}) => {
//     const updatedBooking = {
//       ...booking,
//       [fieldKey]: newValue,
//       ...additionalFields,
//     };
//     setBooking(updatedBooking);
//     updateLeadData(updatedBooking);
//   };

//   // Fetch dropdown options from API
//   useEffect(() => {
//     const fetchDropdownOptions = async () => {
//       if (cachedMoveFromMoveToOptions && cachedMoveSizeOptions) {
//         setMoveFromMoveToOptions(cachedMoveFromMoveToOptions);
//         setMoveSizeOptions(cachedMoveSizeOptions);
//         setFetchError(null);
//         return;
//       }

//       try {
//         const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/emailtemp1", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();

//         if (data.status === "success" && data.data) {
//           const fixedDataString = data.data.replace(/:\{([^}]+)\}/g, ':[$1]');
//           const parsedDataArray = JSON.parse(fixedDataString);
//           const allOptions = {};
//           parsedDataArray.forEach(obj => {
//             Object.assign(allOptions, obj);
//           });

//           const moveFromMoveToList = allOptions.Move_FromMove_To || [];
//           const uniqueMoveFromMoveTo = [...moveFromMoveToList].sort();
//           setMoveFromMoveToOptions(uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]);
//           cachedMoveFromMoveToOptions = uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"];

//           const moveSizeList = allOptions.MoveSize || [];
//           const uniqueMoveSize = [...moveSizeList].sort();
//           setMoveSizeOptions(uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"]);
//           cachedMoveSizeOptions = uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"];

//           setFetchError(null);
//         } else {
//           setFetchError("No options found in response");
//           setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
//           setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
//         }
//       } catch (error) {
//         console.error("Error fetching dropdown options:", error.message);
//         setFetchError(error.message);
//         setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
//         setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
//       }
//     };
//     fetchDropdownOptions();
//   }, [accessToken]);

//   const toggleMoveType = () => {
//     setMoveType((prevType) => (prevType === "local" ? "long" : "local"));
//   };

//   return (
//     <div className="lead-details-lead-details-container">
//       {fetchError && (
//         <div style={{ color: "red", marginBottom: "10px" }}>
//           Error fetching dropdown options: {fetchError}. Using fallback options.
//         </div>
//       )}
//       <div className="lead-header sticky-header">
//         <div className="lead-header-title" style={{ display: "flex" }}>
//           <h2>{booking.Customer_Name} - {booking.LeadACVLRecordID}</h2>
//           <h4 style={{ margin: "0px", marginLeft: "10px", padding: "4px 10px", background: "#ffffff", color: "#000", borderRadius: "10px" }}>
//             {booking.Lead_Status}
//           </h4>
//         </div>
//         <div className="lead-header-icons">
//         <a href={`tel:${booking.Phone_Number}`} title="Call" className="tooltip">
//           <FaPhone />
//         </a>
//         <button 
//           style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
//           onClick={handleMessageClick} 
//           title="Message"
//           className="tooltip"
//         >
//           <FaComment />
//         </button>
//         <button 
//           style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
//           onClick={handleEmailClick} 
//           title="Email"
//           className="tooltip"
//         >
//           <FaEnvelope />
//         </button>
//         <button style={{fontSize:"20px"}} onClick={onClose}>×</button>
//       </div>
//       </div> 

//       <div className="lead-content">
//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleSmsEmail} style={{ cursor: "pointer",marginTop:"10px" }}>
//             <h2 className="lead-section-title">
//               Customer Contact
//               <button onClick={(e) => { e.stopPropagation(); toggleSmsEmail(); }}></button>
//             </h2>
//           </div>
//           {isSmsEmailExpanded && (
//             <SmsEmail 
//               accessToken={accessToken} 
//               LeadACVLRecordID={booking.LeadACVLRecordID} 
//               PhoneNumber={booking.Phone_Number} 
//               Email={booking.Email}
//               initialMode={smsEmailMode}
//             />
//           )}
//         </div>

//         <Estimate accessToken={accessToken} booking={booking} userDetails={userDetails} userMap={userMap} updateLeadData={updateLeadData} />
        
//         <div className="mt-4">
//           {sections.map((section, index) => (
//             <Section
//               key={index}
//               title={section.title}
//               fields={section.fields}
//               booking={booking}
//               accessToken={accessToken}
//               userMap={userMap}
//               userDetails={userDetails}
//               updateBooking={updateBooking}
//               moveFromMoveToOptions={moveFromMoveToOptions}
//               moveSizeOptions={moveSizeOptions}
//             />
//           ))}
//         </div>

//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleStatus} style={{ cursor: "pointer" }}>
//             <h2 className="lead-section-title">
//               Status Change
//               <button onClick={(e) => { e.stopPropagation(); toggleStatus(); }}></button>
//             </h2>
//           </div>
//           {isStatusExpanded && (
//             <StatusChange
//               booking={booking}
//               updateBooking={updateBooking}
//               accessToken={accessToken}
//               userMap={userMap}
//               userDetails={userDetails}
//             />
//           )}
//         </div>

//         <div className="notes-section">
//           <div className="lead-section-header" onClick={toggleNotes} style={{ cursor: "pointer" }}>
//             <h2 className="lead-section-title">
//               Notes
//               <button onClick={(e) => { e.stopPropagation(); toggleNotes(); }}></button>
//             </h2>
//           </div>
//           {isNotesExpanded && <Notes 
//                                 notes={notes} 
//                                 refetchNotes={refetchNotes} 
//                                 accessToken={accessToken} 
//                                 LeadId={booking.LeadACVLRecordID} 
//                                 userDetails={userDetails} 
//                                 updateLeadData={updateLeadData}
//                                 rowId={booking.ROWID} 
//                                 />}
//         </div>
//         <div className="status-section">
//         <div
//           className="lead-section-header"
//           onClick={toggleCost}
//           style={{
//             cursor: "pointer",
//             marginTop: "10px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between"
//           }}
//         >
//           <h2 className="lead-section-title" style={{ margin: 0 }}>
//             {moveType === "local" ? "Local Distance Move Cost Calculator" : "Long Distance Move Cost Calculator"}
//           </h2>

//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 toggleMoveType();
//               }}
//               style={{
//                 padding: "4px 10px",
//                 borderRadius: "6px",
//                 border: "1px solid #ccc",
//                 cursor: "pointer",
//                 background: "#fff",
//                 fontSize: "14px"
//               }}
//             >
//               {moveType === "local" ? "Switch to Long Move" : "Switch to Local Move"}
//             </button>
//           </div>
//         </div>

//         {isCostExpanded && (
//           <>
//             {moveType === "local" ? (
//               <MoveCostCalculator
//                 booking={booking}
//                 updateBooking={updateBooking}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 userDetails={userDetails}
//               />
//             ) : (
//               <LongMoveCostCalculator
//                 booking={booking}
//                 updateBooking={updateBooking}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 userDetails={userDetails}
//               />
//             )}
//           </>
//         )}
//         </div>

//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleCall} style={{ cursor: "pointer",marginTop:"10px" }}>
//             <h2 className="lead-section-title">
//               Call Script - Terms & Conditions
//               <button onClick={(e) => { e.stopPropagation(); toggleCall(); }}></button>
//             </h2>
//           </div>
//           {isCallExpanded && (
//             <CallScript accessToken={accessToken} />
//           )}
//         </div>


//       </div>
//     </div>
//   );
// };

// const Section = ({ title, fields, booking, accessToken, userMap, userDetails, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const toggleExpand = () => setIsExpanded(!isExpanded);

//   const isLeadInfoSection = title === "Lead Information";
//   const hasDuplicateDetails = booking && booking.Duplicate_Lead_Details && booking.Duplicate_Lead_Details.trim() !== "";
//   const isReturnStatus = booking && booking.Lead_Source_Status === "Return";

//   let updatedFields = [...fields];

//   if (isLeadInfoSection) {
//     const returnFields = [
//       { label: "Return Category", key: "Return_Category" },
//       { label: "Return Outcome", key: "Return_Outcome" },
//       { label: "Return Reason Provide", key: "Return_Reason_Provide" },
//       { label: "Return Outcome Reason", key: "Return_Outcome_Reason" },
//     ];

//     const leadSourceStatusIndex = fields.findIndex(field => field.key === "Lead_Source_Status");

//     updatedFields.push({ label: "Duplicate Lead Details", key: "Duplicate_Lead_Details" });

//     if (isReturnStatus && leadSourceStatusIndex !== -1) {
//       updatedFields.splice(leadSourceStatusIndex + 2, 0, ...returnFields);
//     }
//   }

//   const headerStyle = {
//     cursor: "pointer",
//     background: isLeadInfoSection && hasDuplicateDetails ? "#FF0000" : "#4169E1",
//     padding: "15px 20px",
//     borderRadius: "8px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//     boxSizing: "border-box",
//     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
//     animation: "EstimateFadeIn 0.5s ease-in-out",
//     height: "60px",
//   };

//   const getHrStyle = (key) => {
//     if (key === "Lead_Source_Status") {
//       return { margin: "62px 0px 10px 0", width: "110%", background: "black" };
//     } else if (key === "Duplicate_Lead_Details") {
//       return { margin: "19.5px 0", width: "100%", background: "black" };
//     }
//     return {};
//   };

//   return (
//     <div className="lead-section">
//       <div className="lead-section-header" style={headerStyle} onClick={toggleExpand}>
//         <h2 className="lead-section-title">
//           {title}
//           <button onClick={(e) => { e.stopPropagation(); toggleExpand(); }}></button>
//         </h2>
//       </div>
//       {isExpanded && (
//         <div className="lead-section-content">
//           {updatedFields.map((field, index) => {
//             if (field.isPlaceholder) {
//               return <div key={index} style={{ visibility: "hidden" }}></div>;
//             }

//             const shouldShowHr = isLeadInfoSection && isReturnStatus &&
//               (field.key === "Lead_Source_Status" || field.key === "Duplicate_Lead_Details");

//             return (
//               <div key={index}>
//                 <EditableField
//                   label={field.label}
//                   value={booking[field.key]}
//                   rowId={booking.ROWID}
//                   fieldKey={field.key}
//                   accessToken={accessToken}
//                   userMap={userMap}
//                   userDetails={userDetails}
//                   booking={booking}
//                   updateBooking={updateBooking}
//                   moveFromMoveToOptions={moveFromMoveToOptions}
//                   moveSizeOptions={moveSizeOptions}
//                 />
//                 {shouldShowHr && <hr style={getHrStyle(field.key)} />}
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// const EditableField = ({ label, value, rowId, fieldKey, accessToken, userMap, userDetails, booking, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentValue, setCurrentValue] = useState(value);
//   const [tempValue, setTempValue] = useState(value);
//   const [showEditIcon, setShowEditIcon] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [filteredOptions, setFilteredOptions] = useState(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
//   const [highlightedIndex, setHighlightedIndex] = useState(-1);
//   const inputRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const [returnFields, setReturnFields] = useState({
//     Return_Category: booking.Return_Category || "",
//     Return_Reason_Provide: booking.Return_Reason_Provide || "",
//     Return_Outcome: booking.Return_Outcome || "",
//     Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
//   });

//   const returnCategoryOptions = [
//     "Returned - Already Moved",
//     "Returned - Duplicate",
//     "Returned - Invalid",
//     "Returned - Need only Estimate",
//     "Returned - No Budget",
//     "Returned - Test Lead",
//     "Returned - Wrong Number",
//   ];

//   const returnOutcomeOptions = [
//     "Approved",
//     "Rejected",
//   ];

//   useEffect(() => {
//     setCurrentValue(value);
//     setTempValue(value || "");
//     setIsEditing(false);
//     setErrorMessage("");
//     setShowDropdown(false);
//     setFilteredOptions(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
//     setHighlightedIndex(-1);
//     setReturnFields({
//       Return_Category: booking.Return_Category || "",
//       Return_Reason_Provide: booking.Return_Reason_Provide || "",
//       Return_Outcome: booking.Return_Outcome || "",
//       Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
//     });
//   }, [value, booking, moveFromMoveToOptions, moveSizeOptions, fieldKey]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
//         setShowDropdown(false);
//         setHighlightedIndex(-1);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const nonEditableFields = [
//     "LeadACVLRecordID",
//     "Received_Time_IST",
//     "Received_Date_EST",
//     "Banner",
//     "LeadProviderLeadId",
//     "Lead_Status",
//     // "Lead_Source",
//     "Lead_Priority",
//     "Duplicate",
//     "Duplicate_Lead_Details",
//   ];
//   const isReadOnly = nonEditableFields.includes(fieldKey);

//   // const userOptions = Object.entries(userMap).map(([userId, userName]) => ({
//   //   id: userId,
//   //   name: userName,
//   // }));
//   // Filter out users with blank pseudoname (assuming userMap maps userId to userName/pseudoname)
//   const userOptions = Object.entries(userMap)
//     .filter(([userId, userName]) => userName && userName.trim() !== "")
//     .map(([userId, userName]) => ({
//       id: userId,
//       name: userName,
//     }));

//   const validateCityFormat = (input) => {
//     const cityFormatRegex = /^[A-Za-z\s\-.']+,\s[A-Z]{2}$/;
//     return cityFormatRegex.test(input);
//   };

//   const handleInputChange = (e) => {
//     const input = e.target.value;
//     setTempValue(input);
//     setErrorMessage("");

//     if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
//       const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
//       if (input.trim() === "") {
//         setFilteredOptions(options);
//         setShowDropdown(true);
//       } else {
//         const filtered = options.filter(option =>
//           option.toLowerCase().startsWith(input.toLowerCase())
//         );
//         setFilteredOptions(filtered);
//         setShowDropdown(true);
//       }
//       setHighlightedIndex(-1);
//     }
//   };

//   const handleOptionSelect = (option) => {
//     setTempValue(option);
//     setShowDropdown(false);
//     setHighlightedIndex(-1);
//     if (inputRef.current) {
//       inputRef.current.focus();
//     }
//   };

//   const handleInputFocus = () => {
//     if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
//       setShowDropdown(true);
//       const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
//       setFilteredOptions(tempValue ? options.filter(option =>
//         option.toLowerCase().startsWith(tempValue.toLowerCase())
//       ) : options);
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (!["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey) || !showDropdown) return;

//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setHighlightedIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : 0));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setHighlightedIndex(prev => (prev > 0 ? prev - 1 : filteredOptions.length - 1));
//     } else if (e.key === "Enter" && highlightedIndex >= 0) {
//       e.preventDefault();
//       handleOptionSelect(filteredOptions[highlightedIndex]);
//     } else if (e.key === "Escape") {
//       setShowDropdown(false);
//       setHighlightedIndex(-1);
//     }
//   };

//   const handleSave = async () => {
//     if (isReadOnly) return;

//     // Validate city format for OriginCity and DestinationCity
//     if (["OriginCity", "DestinationCity"].includes(fieldKey) && tempValue && !validateCityFormat(tempValue)) {
//       setErrorMessage("Please enter the city in the format 'City name, XX' (e.g., 'Toronto, ON')");
//       return;
//     }

//     // Validate Move_Size (only check for non-empty)
//     if (fieldKey === "Move_Size" && !tempValue.trim()) {
//       setErrorMessage("Please enter a move size");
//       return;
//     }

//     const previousBooking = { ...booking };
//     let updatedData = [{ ROWID: rowId, [fieldKey]: tempValue }];
//     let additionalFields = {};

//     if (fieldKey === "AssignedUserID") {
//       const selectedUser = userOptions.find((user) => user.id === tempValue);
//       if (selectedUser) {
//         updatedData[0].Sales_Agent = selectedUser.name;
//         additionalFields.Sales_Agent = selectedUser.name;
//       }
//     } else if (fieldKey === "Lead_Source_Status" && tempValue === "Return") {
//       updatedData[0] = {
//         ...updatedData[0],
//         Return_Category: returnFields.Return_Category,
//         Return_Reason_Provide: returnFields.Return_Reason_Provide,
//         Return_Outcome: returnFields.Return_Outcome,
//         Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
//       };
//       additionalFields = {
//         ...additionalFields,
//         Return_Category: returnFields.Return_Category,
//         Return_Reason_Provide: returnFields.Return_Reason_Provide,
//         Return_Outcome: returnFields.Return_Outcome,
//         Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
//       };
//     } else if (fieldKey === "Lead_Source_Status" && tempValue === "Valid") {
//       updatedData[0] = {
//         ...updatedData[0],
//         Return_Category: "",
//         Return_Reason_Provide: "",
//         Return_Outcome: "",
//         Return_Outcome_Reason: "",
//       };
//       additionalFields = {
//         ...additionalFields,
//         Return_Category: "",
//         Return_Reason_Provide: "",
//         Return_Outcome: "",
//         Return_Outcome_Reason: "",
//       };
//     } else if (["Return_Category", "Return_Reason_Provide", "Return_Outcome", "Return_Outcome_Reason"].includes(fieldKey)) {
//       updatedData[0] = {
//         ...updatedData[0],
//         [fieldKey]: tempValue,
//       };
//       additionalFields = {
//         ...additionalFields,
//         [fieldKey]: tempValue,
//       };
//     } else {
//       if (!booking.AssignedUserID) {
//         updatedData[0].AssignedUserID = userDetails.userId;
//         const defaultUser = userOptions.find((user) => user.id === userDetails.userId);
//         if (defaultUser) {
//           updatedData[0].Sales_Agent = defaultUser.name;
//           additionalFields.AssignedUserID = userDetails.userId;
//           additionalFields.Sales_Agent = defaultUser.name;
//         }
//       }
//     }
//     console.log (updatedData);
//     try {
//       updateBooking(fieldKey, tempValue, additionalFields);
//       const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/leadsdata", {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${accessToken}`,
//         },
//         body: JSON.stringify(updatedData),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to save data");
//       }

//       // console.log("Save successful, updated booking:", booking);
//       setCurrentValue(tempValue);
//       setIsEditing(false);
//       setErrorMessage("");
//       setShowDropdown(false);
//     } catch (error) {
//       console.error("Error updating field", error);
//       updateBooking(fieldKey, previousBooking[fieldKey], {
//         Sales_Agent: previousBooking.Sales_Agent,
//         AssignedUserID: previousBooking.AssignedUserID,
//         Return_Category: previousBooking.Return_Category,
//         Return_Reason_Provide: previousBooking.Return_Reason_Provide,
//         Return_Outcome: previousBooking.Return_Outcome,
//         Return_Outcome_Reason: previousBooking.Return_Outcome_Reason,
//       });
//       setTempValue(currentValue);
//       setReturnFields({
//         Return_Category: previousBooking.Return_Category || "",
//         Return_Reason_Provide: previousBooking.Return_Reason_Provide || "",
//         Return_Outcome: previousBooking.Return_Outcome || "",
//         Return_Outcome_Reason: previousBooking.Return_Outcome_Reason || "",
//       });
//       setErrorMessage("Failed to save changes. Please try again.");
//     }
//   };

//   const handleCancel = () => {
//     setTempValue(currentValue);
//     setReturnFields({
//       Return_Category: booking.Return_Category || "",
//       Return_Reason_Provide: booking.Return_Reason_Provide || "",
//       Return_Outcome: booking.Return_Outcome || "",
//       Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
//     });
//     setIsEditing(false);
//     setErrorMessage("");
//     setShowDropdown(false);
//     setHighlightedIndex(-1);
//   };

//   const handleInputClick = () => {
//     if (!isReadOnly) {
//       setIsEditing(true);
//       setShowDropdown(["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey));
//     }
//   };

//   if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
//     // console.log(`Rendering ${fieldKey} with tempValue:`, tempValue);
//     // console.log(`Rendering ${fieldKey} with moveFromMoveToOptions:`, moveFromMoveToOptions);
//     // console.log(`Rendering ${fieldKey} with moveSizeOptions:`, moveSizeOptions);
//     // console.log(`Rendering ${fieldKey} with filteredOptions:`, filteredOptions);
//   }

//   return (
//     <div className="editable-field" onMouseEnter={() => setShowEditIcon(true)} onMouseLeave={() => setShowEditIcon(false)}>
//       <label>{label}</label>
//       {errorMessage && (
//         <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
//           {errorMessage}
//         </div>
//       )}
//       <div className="input-container" style={{ display: "flex", alignItems: "center" }}>
//         {fieldKey === "AssignedUserID" ? (
//           isEditing ? (
//             <select value={tempValue || ""} onChange={e => setTempValue(e.target.value)} className="editable-input" style={{ width: "100%", padding: "8px" }}>
//               <option value="">Select User</option>
//               {userOptions.map((user) => (
//                 <option key={user.id} value={user.id}>
//                   {user.name}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={userMap[currentValue] || "Select User"}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "Move_Date"  || fieldKey === "DeliveryDate" ? (
//           isEditing ? (
//             <input
//               type="date"
//               style={{ width: "80%", padding: "8px" }}
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               autoFocus
//             />
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "Duplicate_Lead_Details" ? (
//           <textarea
//             value={tempValue || ""}
//             readOnly
//             className="read-only-input"
//             style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
//           />
//         ) : fieldKey === "Return_Reason_Provide" || fieldKey === "Return_Outcome_Reason" 
//         || fieldKey === "ToolsRequired" || fieldKey === "PackingSupplies" || fieldKey === "Inventory_List" || fieldKey === "Customer_Instructions" ? (
//           isEditing ? (
//             <textarea
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
//             />
//           ) : (
//             <textarea
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "Return_Category" ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Return Category</option>
//               {returnCategoryOptions.map((option) => (
//                 <option key={option} value={option}>
//                   {option}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "Lead_Source_Status" ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Status</option>
//               <option value="Valid">Valid</option>
//               <option value="Return">Return</option>
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "OriginPropertyType" || fieldKey === "DestinationPropertyType" ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Status</option>
//               <option value="Apartment">Apartment</option>
//               <option value="Condo">Condo</option>
//               <option value="Townhouse">Townhouse</option>
//               <option value="House">House</option>
//               <option value="Storage">Storage</option>
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ): fieldKey === "Return_Outcome" ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Return Outcome</option>
//               {returnOutcomeOptions.map((option) => (
//                 <option key={option} value={option}>
//                   {option}
//                 </option>
//               ))}
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ): fieldKey === "FlexibleDeliveryDate" || fieldKey === "NeedPackingServices"
//         || fieldKey === "ParkingAvailableAtOrigin" || fieldKey === "HeavyEquipments"
//         || fieldKey === "ParkingAvailableAtDestination" || fieldKey === "ServiceElevatoratOrigin"
//         || fieldKey === "ServiceElevatoratDestination" ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Option</option>
//               <option value="No">No</option>
//               <option value="Yes">Yes</option>
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ): fieldKey === "DismantlingOfFurnitures"  ? (
//           isEditing ? (
//             <select
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             >
//               <option value="">Select Option</option>
//               <option value="Required">Required</option>
//               <option value="Not required">Not required</option>
//             </select>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "LongWalkAtDestination" || fieldKey === "LongWalkAtOrigin"  ? (
//           isEditing ? (
//             <input
//               type="number"
//               value={tempValue || ""}
//               placeholder="Long walks in Yaurds"
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           ) : (
//             <input
//               type="number"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "NoOfStaircasesAtDestination" || fieldKey === "NoOfStaircasesAtOrigin" ? (
//           isEditing ? (
//             <input
//               type="number"
//               value={tempValue || ""}
//               placeholder="Enter the count of staircases"
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           ) : (
//             <input
//               type="number"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : fieldKey === "OriginCity" || fieldKey === "DestinationCity" || fieldKey === "Move_Size" ? (
//           isEditing ? (
//             <div style={{ position: "relative", width: "100%" }}>
//               <input
//                 type="text"
//                 ref={inputRef}
//                 value={tempValue || ""}
//                 onChange={handleInputChange}
//                 onFocus={handleInputFocus}
//                 onKeyDown={handleKeyDown}
//                 className="editable-input"
//                 style={{ width: "100%", padding: "8px", minHeight: "34px" }}
//                 placeholder={fieldKey === "Move_Size" ? "Enter or select move size (e.g., 2 Bedroom)" : "Enter or select city (e.g., Toronto, ON)"}
//                 autoFocus
//               />
//               {showDropdown && filteredOptions.length > 0 && (
//                 <ul
//                   ref={dropdownRef}
//                   style={{
//                     position: "absolute",
//                     top: "100%",
//                     left: 0,
//                     right: 0,
//                     background: "#fff",
//                     border: "1px solid #ccc",
//                     borderRadius: "4px",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                     maxHeight: "200px",
//                     overflowY: "auto",
//                     listStyle: "none",
//                     padding: 0,
//                     margin: 0,
//                     zIndex: 1000,
//                   }}
//                 >
//                   {filteredOptions.map((option, index) => (
//                     <li
//                       key={option}
//                       onClick={() => handleOptionSelect(option)}
//                       onMouseEnter={() => setHighlightedIndex(index)}
//                       style={{
//                         padding: "8px",
//                         cursor: "pointer",
//                         background: highlightedIndex === index ? "#f0f0f0" : "transparent",
//                       }}
//                     >
//                       {option}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         ) : (
//           isEditing ? (
//             <input
//               type="text"
//               value={tempValue || ""}
//               onChange={e => setTempValue(e.target.value)}
//               className="editable-input"
//               style={{ width: "100%", padding: "8px" }}
//               autoFocus
//             />
//           ) : (
//             <input
//               type="text"
//               value={tempValue || ""}
//               readOnly
//               onClick={handleInputClick}
//               className={isReadOnly ? "read-only-input" : "editable-input"}
//               style={{ width: "100%", padding: "8px" }}
//             />
//           )
//         )}
//         {!isReadOnly && isEditing ? (
//           <div className="edit-icons" style={{ marginLeft: "10px" }}>
//             <FaCheck onClick={handleSave} className="save-icon" />
//             <FaTimes onClick={handleCancel} className="cancel-icon" />
//           </div>
//         ) : (
//           !isReadOnly && showEditIcon && <FaPen className="edit-icon" onClick={() => setIsEditing(true)} style={{ marginLeft: "10px" }} />
//         )}
//       </div>
//     </div>
//   );
// };

// const sections = [
//   {
//     title: "Lead Information",
//     fields: [
//       { label: "Sales Agent", key: "AssignedUserID" },
//       // { label: "Move Type", key: "Move_Type" },
//       { label: "ACVL LeadID", key: "LeadACVLRecordID" },
//       { label: "Received Date IST", key: "Received_Time_IST" },
//       { label: "Received Date EST", key: "Received_Date_EST" },
//       { label: "Banner", key: "Banner" },
//       { label: "Lead Priority", key: "Lead_Priority" },
//       // { label: "Lead Source ID", key: "LeadProviderLeadId" },
//       { label: "Lead Source Status", key: "Lead_Source_Status" },
//     ],
//   },
//   {
//     title: "Customer Information",
//     fields: [
//       { label: "Customer Name", key: "Customer_Name" },
//       { label: "Phone Number", key: "Phone_Number" },
//       { label: "Alternate Phone Number", key: "Alt_Phone_Number" },
//       { label: "Email", key: "Email" },
//     ],
//   },
//   {
//     title: "Move Details",
//     fields: [
//       { label: "Move Size", key: "Move_Size" },
//       { label: "Move Type", key: "Move_Type" },
//       { label: "Move Date", key: "Move_Date" },
//       { label: "Delivery Date", key: "DeliveryDate" },
//       { label: "Flexible for Delivery Date", key: "FlexibleDeliveryDate" },
//       { label: "From Province", key: "OriginCity" },
//       { label: "To Province", key: "DestinationCity" },
//       { label: "From Address", key: "FromAddress" },
//       { label: "To Address", key: "ToAddress" },
//       { label: "From PostCode", key: "FromPostCode" },
//       { label: "To PostCode", key: "ToPostCode" },
//       { label: "Origin property type", key: "OriginPropertyType" },
//       { label: "Destination property type", key: "DestinationPropertyType" },
//       { label: "No of staircases at origin", key: "NoOfStaircasesAtOrigin" }, 
//       { label: "No of staircases at destination", key: "NoOfStaircasesAtDestination" }, 
//       { label: "Which floor at origin", key: "WithFloorAtOrigin" }, 
//       { label: "Which floor at destination", key: "WithFloorAtDestination" }, 
//       { label: "Elevator availability at origin", key: "ServiceElevatoratOrigin" },
//       { label: "Elevator availability at destination", key: "ServiceElevatoratDestination" },
//       { label: "Long walk at origin", key: "LongWalkAtOrigin" },
//       { label: "Long walk at destination", key: "LongWalkAtDestination" },
//       { label: "Parking available at origin", key: "ParkingAvailableAtOrigin" },
//       { label: "Parking available at destination", key: "ParkingAvailableAtDestination" },
//       { label: "Heavy equipments", key: "HeavyEquipments" },
//       { label: "Need packing services", key: "NeedPackingServices" }, 
//       { label: "Dismantling of furnitures", key: "DismantlingOfFurnitures" },
//       { label: "Tools required to complete the Move", key: "ToolsRequired" }, 
//       { label: "Packing supplies", key: "PackingSupplies" }, 
//       { label: "Customer Instructions", key: "Customer_Instructions" },
//       { label: "Inventory List", key: "Inventory_List" }, 
//     ],
//   },
// ];

// export default LeadDetails;

// // after the dailpad changes 
import React, { useState, useEffect, useRef } from "react";
import { FaPhone, FaEnvelope, FaComment, FaPen, FaCheck, FaTimes } from "react-icons/fa";
import Estimate from "./Estimate/Estimate";
import Notes from "./Notes/Notes";
import 'react-datepicker/dist/react-datepicker.css';
import StatusChange from "./Status/Statuscard";
import MoveCostCalculator from "./CostCalculator/Costcalculator";
import CallScript from "./CallScript/CallScript";
import LongMoveCostCalculator from "./CostCalculator/LongCostcalculator";
import SmsEmail from "./SmsEmail/SmsEmail";
import Dialpad from "./SmsEmail/Dialpad";


let cachedMoveFromMoveToOptions = null;
let cachedMoveSizeOptions = null;

// const LeadDetails = ({ booking: initialBooking, onClose, accessToken, userDetails, userMap, updateLeadData, notes, refetchNotes }) => {
//   const [booking, setBooking] = useState(initialBooking);
//   const [isNotesExpanded, setIsNotesExpanded] = useState(false);
//   const [isStatusExpanded, setIsStatusExpanded] = useState(false);
//   const [isCostExpanded, setIsCostExpanded] = useState(false);
//   const [isCallExpanded, setIsCallExpanded] = useState(false);
//   const [isSmsEmailExpanded, setIsSmsEmailExpanded] = useState(false);
//   const [smsEmailMode, setSmsEmailMode] = useState('sms');
//   const [moveFromMoveToOptions, setMoveFromMoveToOptions] = useState([]);
//   const [moveSizeOptions, setMoveSizeOptions] = useState([]);
//   const [fetchError, setFetchError] = useState(null);
//   const [moveType, setMoveType] = useState("local"); // default local
//   const [showDialpad, setShowDialpad] = useState(false);
//   const [dialpadPosition, setDialpadPosition] = useState({ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

//   const dialpadRef = useRef(null);

//   const toggleStatus = () => setIsStatusExpanded(!isStatusExpanded);
//   const toggleCost = () => setIsCostExpanded(!isCostExpanded);
//   const toggleNotes = () => setIsNotesExpanded(!isNotesExpanded);
//   const toggleCall = () => setIsCallExpanded(!isCallExpanded);
  
//   const toggleSmsEmail = () => {
//     if (isSmsEmailExpanded) {
//       setIsSmsEmailExpanded(false);
//     } else {
//       setSmsEmailMode('sms');
//       setIsSmsEmailExpanded(true);
//     }
//   };
//   const handleMessageClick = () => {
//     setSmsEmailMode('sms');
//     setIsSmsEmailExpanded(true);
//   };
//   const handleEmailClick = () => {
//     setSmsEmailMode('email');
//     setIsSmsEmailExpanded(true);
//   };

//   const handleCallClick = () => {
//     setShowDialpad(true);
//   };

//   const updateBooking = (fieldKey, newValue, additionalFields = {}) => {
//     const updatedBooking = {
//       ...booking,
//       [fieldKey]: newValue,
//       ...additionalFields,
//     };
//     setBooking(updatedBooking);
//     updateLeadData(updatedBooking);
//   };

//   // Fetch dropdown options from API
//   useEffect(() => {
//     const fetchDropdownOptions = async () => {
//       if (cachedMoveFromMoveToOptions && cachedMoveSizeOptions) {
//         setMoveFromMoveToOptions(cachedMoveFromMoveToOptions);
//         setMoveSizeOptions(cachedMoveSizeOptions);
//         setFetchError(null);
//         return;
//       }

//       try {
//         const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/emailtemp1", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();

//         if (data.status === "success" && data.data) {
//           const fixedDataString = data.data.replace(/:\{([^}]+)\}/g, ':[$1]');
//           const parsedDataArray = JSON.parse(fixedDataString);
//           const allOptions = {};
//           parsedDataArray.forEach(obj => {
//             Object.assign(allOptions, obj);
//           });

//           const moveFromMoveToList = allOptions.Move_FromMove_To || [];
//           const uniqueMoveFromMoveTo = [...moveFromMoveToList].sort();
//           setMoveFromMoveToOptions(uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]);
//           cachedMoveFromMoveToOptions = uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"];

//           const moveSizeList = allOptions.MoveSize || [];
//           const uniqueMoveSize = [...moveSizeList].sort();
//           setMoveSizeOptions(uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"]);
//           cachedMoveSizeOptions = uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"];

//           setFetchError(null);
//         } else {
//           setFetchError("No options found in response");
//           setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
//           setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
//         }
//       } catch (error) {
//         console.error("Error fetching dropdown options:", error.message);
//         setFetchError(error.message);
//         setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
//         setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
//       }
//     };
//     fetchDropdownOptions();
//   }, [accessToken]);

//   const toggleMoveType = () => {
//     setMoveType((prevType) => (prevType === "local" ? "long" : "local"));
//   };

//   // Drag handlers for dialpad
//   const handleMouseDown = (e) => {
//     setIsDragging(true);
//     const rect = dialpadRef.current.getBoundingClientRect();
//     setDragOffset({
//       x: e.clientX - rect.left,
//       y: e.clientY - rect.top
//     });
//   };

//   const handleMouseMove = (e) => {
//     if (!isDragging) return;
//     setDialpadPosition({
//       x: e.clientX - dragOffset.x,
//       y: e.clientY - dragOffset.y
//     });
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener('mousemove', handleMouseMove);
//       document.addEventListener('mouseup', handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//     };
//   }, [isDragging, dragOffset]);

//   return (
//     <div className="lead-details-lead-details-container">
//       {fetchError && (
//         <div style={{ color: "red", marginBottom: "10px" }}>
//           Error fetching dropdown options: {fetchError}. Using fallback options.
//         </div>
//       )}
//       <div className="lead-header sticky-header">
//         <div className="lead-header-title" style={{ display: "flex" }}>
//           <h2>{booking.Customer_Name} - {booking.LeadACVLRecordID}</h2>
//           <h4 style={{ margin: "0px", marginLeft: "10px", padding: "4px 10px", background: "#ffffff", color: "#000", borderRadius: "10px" }}>
//             {booking.Lead_Status}
//           </h4>
//         </div>
//         <div className="lead-header-icons">
//         <button 
//           onClick={handleCallClick} 
//           title="Call" 
//           className="tooltip"
//           style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}}
//         >
//           <FaPhone />
//         </button>
//         <button 
//           style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
//           onClick={handleMessageClick} 
//           title="Message"
//           className="tooltip"
//         >
//           <FaComment />
//         </button>
//         <button 
//           style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
//           onClick={handleEmailClick} 
//           title="Email"
//           className="tooltip"
//         >
//           <FaEnvelope />
//         </button>
//         <button style={{fontSize:"20px"}} onClick={onClose}>×</button>
//       </div>
//       </div> 

//       <div className="lead-content">
//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleSmsEmail} style={{ cursor: "pointer",marginTop:"10px" }}>
//             <h2 className="lead-section-title">
//               Customer Contact
//               <button onClick={(e) => { e.stopPropagation(); toggleSmsEmail(); }}></button>
//             </h2>
//           </div>
//           {isSmsEmailExpanded && (
//             <SmsEmail 
//               accessToken={accessToken} 
//               LeadACVLRecordID={booking.LeadACVLRecordID} 
//               PhoneNumber={booking.Phone_Number} 
//               Email={booking.Email}
//               initialMode={smsEmailMode}
//             />
//           )}
//         </div>

//         <Estimate accessToken={accessToken} booking={booking} userDetails={userDetails} userMap={userMap} updateLeadData={updateLeadData} />
        
//         <div className="mt-4">
//           {sections.map((section, index) => (
//             <Section
//               key={index}
//               title={section.title}
//               fields={section.fields}
//               booking={booking}
//               accessToken={accessToken}
//               userMap={userMap}
//               userDetails={userDetails}
//               updateBooking={updateBooking}
//               moveFromMoveToOptions={moveFromMoveToOptions}
//               moveSizeOptions={moveSizeOptions}
//             />
//           ))}
//         </div>

//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleStatus} style={{ cursor: "pointer" }}>
//             <h2 className="lead-section-title">
//               Status Change
//               <button onClick={(e) => { e.stopPropagation(); toggleStatus(); }}></button>
//             </h2>
//           </div>
//           {isStatusExpanded && (
//             <StatusChange
//               booking={booking}
//               updateBooking={updateBooking}
//               accessToken={accessToken}
//               userMap={userMap}
//               userDetails={userDetails}
//             />
//           )}
//         </div>

//         <div className="notes-section">
//           <div className="lead-section-header" onClick={toggleNotes} style={{ cursor: "pointer" }}>
//             <h2 className="lead-section-title">
//               Notes
//               <button onClick={(e) => { e.stopPropagation(); toggleNotes(); }}></button>
//             </h2>
//           </div>
//           {isNotesExpanded && <Notes 
//                                 notes={notes} 
//                                 refetchNotes={refetchNotes} 
//                                 accessToken={accessToken} 
//                                 LeadId={booking.LeadACVLRecordID} 
//                                 userDetails={userDetails} 
//                                 updateLeadData={updateLeadData}
//                                 rowId={booking.ROWID} 
//                                 />}
//         </div>
//         <div className="status-section">
//         <div
//           className="lead-section-header"
//           onClick={toggleCost}
//           style={{
//             cursor: "pointer",
//             marginTop: "10px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between"
//           }}
//         >
//           <h2 className="lead-section-title" style={{ margin: 0 }}>
//             {moveType === "local" ? "Local Distance Move Cost Calculator" : "Long Distance Move Cost Calculator"}
//           </h2>

//           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 toggleMoveType();
//               }}
//               style={{
//                 padding: "4px 10px",
//                 borderRadius: "6px",
//                 border: "1px solid #ccc",
//                 cursor: "pointer",
//                 background: "#fff",
//                 fontSize: "14px"
//               }}
//             >
//               {moveType === "local" ? "Switch to Long Move" : "Switch to Local Move"}
//             </button>
//           </div>
//         </div>

//         {isCostExpanded && (
//           <>
//             {moveType === "local" ? (
//               <MoveCostCalculator
//                 booking={booking}
//                 updateBooking={updateBooking}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 userDetails={userDetails}
//               />
//             ) : (
//               <LongMoveCostCalculator
//                 booking={booking}
//                 updateBooking={updateBooking}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 userDetails={userDetails}
//               />
//             )}
//           </>
//         )}
//         </div>

//         <div className="status-section">
//           <div className="lead-section-header" onClick={toggleCall} style={{ cursor: "pointer",marginTop:"10px" }}>
//             <h2 className="lead-section-title">
//               Call Script - Terms & Conditions
//               <button onClick={(e) => { e.stopPropagation(); toggleCall(); }}></button>
//             </h2>
//           </div>
//           {isCallExpanded && (
//             <CallScript accessToken={accessToken} />
//           )}
//         </div>


//       </div>

//       {/* Draggable Dialpad Overlay */}
//       {showDialpad && (
//         <>
//           <div 
//             style={{ 
//               position: 'fixed', 
//               top: 0, 
//               left: 0, 
//               width: '100%', 
//               backgroundColor: 'rgba(0,0,0,0.5)', 
//               zIndex: 1000 
//             }} 
//             onClick={() => setShowDialpad(false)}
//           />
//           <div 
//             ref={dialpadRef}
//             style={{ 
//               position: 'fixed', 
//               left: `${dialpadPosition.x}px`, 
//               top: `${dialpadPosition.y}px`, 
//               background:  'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',  
//               padding: '2px',
//               borderRadius: '10px', 
//               zIndex: 1001,
//               boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
//             }} 
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div 
//               style={{ 
//                 display: 'flex', 
//                 justifyContent: 'space-between', 
//                 alignItems: 'center', 
//                 marginBottom: '10px',
//                 cursor: 'move',
//                 padding: '5px 0'
//               }} 
//               onMouseDown={handleMouseDown}
//             >
//               {/* <h3>Dialpad</h3>
//               <button 
//                 onClick={() => setShowDialpad(false)} 
//                 style={{ 
//                   background: 'none', 
//                   border: 'none', 
//                   fontSize: '20px', 
//                   cursor: 'pointer' 
//                 }}
//               >
//                 ×
//               </button> */}
//             </div>
//             <Dialpad
//               phoneNumber={booking.Phone_Number} 
//               onClose={() => setShowDialpad(false)} 
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// };
// after dialpad changes for outgoing 
const LeadDetails = ({ booking: initialBooking, onClose, accessToken, userDetails, userMap, updateLeadData, notes, refetchNotes, onOpenDialpad, telnyxClient, currentCall, onMakeCall, onEndCall, telnyxConnected }) => {
  const [booking, setBooking] = useState(initialBooking);
  const [isNotesExpanded, setIsNotesExpanded] = useState(false);
  const [isStatusExpanded, setIsStatusExpanded] = useState(false);
  const [isCostExpanded, setIsCostExpanded] = useState(false);
  const [isCallExpanded, setIsCallExpanded] = useState(false);
  const [isSmsEmailExpanded, setIsSmsEmailExpanded] = useState(false);
  const [smsEmailMode, setSmsEmailMode] = useState('sms');
  const [moveFromMoveToOptions, setMoveFromMoveToOptions] = useState([]);
  const [moveSizeOptions, setMoveSizeOptions] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [moveType, setMoveType] = useState("local"); // default local

  const toggleStatus = () => setIsStatusExpanded(!isStatusExpanded);
  const toggleCost = () => setIsCostExpanded(!isCostExpanded);
  const toggleNotes = () => setIsNotesExpanded(!isNotesExpanded);
  const toggleCall = () => setIsCallExpanded(!isCallExpanded);
  
  const toggleSmsEmail = () => {
    if (isSmsEmailExpanded) {
      setIsSmsEmailExpanded(false);
    } else {
      setSmsEmailMode('sms');
      setIsSmsEmailExpanded(true);
    }
  };
  const handleMessageClick = () => {
    setSmsEmailMode('sms');
    setIsSmsEmailExpanded(true);
  };
  const handleEmailClick = () => {
    setSmsEmailMode('email');
    setIsSmsEmailExpanded(true);
  };

  const handleCallClick = () => {
    if (onOpenDialpad) {
      onOpenDialpad(booking.Phone_Number);
    }
  };

  const updateBooking = (fieldKey, newValue, additionalFields = {}) => {
    const updatedBooking = {
      ...booking,
      [fieldKey]: newValue,
      ...additionalFields,
    };
    setBooking(updatedBooking);
    updateLeadData(updatedBooking);
  };

  // Fetch dropdown options from API
  useEffect(() => {
    const fetchDropdownOptions = async () => {
      if (cachedMoveFromMoveToOptions && cachedMoveSizeOptions) {
        setMoveFromMoveToOptions(cachedMoveFromMoveToOptions);
        setMoveSizeOptions(cachedMoveSizeOptions);
        setFetchError(null);
        return;
      }

      try {
        const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/emailtemp1", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        if (data.status === "success" && data.data) {
          const fixedDataString = data.data.replace(/:\{([^}]+)\}/g, ':[$1]');
          const parsedDataArray = JSON.parse(fixedDataString);
          const allOptions = {};
          parsedDataArray.forEach(obj => {
            Object.assign(allOptions, obj);
          });

          const moveFromMoveToList = allOptions.Move_FromMove_To || [];
          const uniqueMoveFromMoveTo = [...moveFromMoveToList].sort();
          setMoveFromMoveToOptions(uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"]);
          cachedMoveFromMoveToOptions = uniqueMoveFromMoveTo.length > 0 ? uniqueMoveFromMoveTo : ["Mississauga, ON", "Brampton, ON"];

          const moveSizeList = allOptions.MoveSize || [];
          const uniqueMoveSize = [...moveSizeList].sort();
          setMoveSizeOptions(uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"]);
          cachedMoveSizeOptions = uniqueMoveSize.length > 0 ? uniqueMoveSize : ["3 Bedroom", "4 Bedroom"];

          setFetchError(null);
        } else {
          setFetchError("No options found in response");
          setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
          setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error.message);
        setFetchError(error.message);
        setMoveFromMoveToOptions(["Mississauga, ON", "Brampton, ON"]);
        setMoveSizeOptions(["3 Bedroom", "4 Bedroom"]);
      }
    };
    fetchDropdownOptions();
  }, [accessToken]);

  const toggleMoveType = () => {
    setMoveType((prevType) => (prevType === "local" ? "long" : "local"));
  };

  return (
    <div className="lead-details-lead-details-container">
      {fetchError && (
        <div style={{ color: "red", marginBottom: "10px" }}>
          Error fetching dropdown options: {fetchError}. Using fallback options.
        </div>
      )}
      <div className="lead-header sticky-header">
        <div className="lead-header-title" style={{ display: "flex" }}>
          <h2>{booking.Customer_Name} - {booking.LeadACVLRecordID}</h2>
          <h4 style={{ margin: "0px", marginLeft: "10px", padding: "4px 10px", background: "#ffffff", color: "#000", borderRadius: "10px" }}>
            {booking.Lead_Status}
          </h4>
        </div>
        <div className="lead-header-icons">
        <button 
          onClick={handleCallClick} 
          title="Call" 
          className="tooltip"
          style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}}
        >
          <FaPhone />
        </button>
        <button 
          style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
          onClick={handleMessageClick} 
          title="Message"
          className="tooltip"
        >
          <FaComment />
        </button>
        <button 
          style={{background:"none", border:"none", color:"#ffffff", cursor: "pointer"}} 
          onClick={handleEmailClick} 
          title="Email"
          className="tooltip"
        >
          <FaEnvelope />
        </button>
        <button style={{fontSize:"20px"}} onClick={onClose}>×</button>
      </div>
      </div> 

      <div className="lead-content">
        <div className="status-section">
          <div className="lead-section-header" onClick={toggleSmsEmail} style={{ cursor: "pointer",marginTop:"10px" }}>
            <h2 className="lead-section-title">
              Customer Contact
              <button onClick={(e) => { e.stopPropagation(); toggleSmsEmail(); }}></button>
            </h2>
          </div>
          {isSmsEmailExpanded && (
            <SmsEmail 
              accessToken={accessToken} 
              LeadACVLRecordID={booking.LeadACVLRecordID} 
              PhoneNumber={booking.Phone_Number} 
              Email={booking.Email}
              initialMode={smsEmailMode}
              Salesagent={booking.Sales_Agent}
            />
          )}
        </div>

        <Estimate accessToken={accessToken} booking={booking} userDetails={userDetails} userMap={userMap} updateLeadData={updateLeadData} />
        
        <div className="mt-4">
          {sections.map((section, index) => (
            <Section
              key={index}
              title={section.title}
              fields={section.fields}
              booking={booking}
              accessToken={accessToken}
              userMap={userMap}
              userDetails={userDetails}
              updateBooking={updateBooking}
              moveFromMoveToOptions={moveFromMoveToOptions}
              moveSizeOptions={moveSizeOptions}
            />
          ))}
        </div>

        <div className="status-section">
          <div className="lead-section-header" onClick={toggleStatus} style={{ cursor: "pointer" }}>
            <h2 className="lead-section-title">
              Status Change
              <button onClick={(e) => { e.stopPropagation(); toggleStatus(); }}></button>
            </h2>
          </div>
          {isStatusExpanded && (
            <StatusChange
              booking={booking}
              updateBooking={updateBooking}
              accessToken={accessToken}
              userMap={userMap}
              userDetails={userDetails}
            />
          )}
        </div>

        <div className="notes-section">
          <div className="lead-section-header" onClick={toggleNotes} style={{ cursor: "pointer" }}>
            <h2 className="lead-section-title">
              Notes
              <button onClick={(e) => { e.stopPropagation(); toggleNotes(); }}></button>
            </h2>
          </div>
          {isNotesExpanded && <Notes 
                                notes={notes} 
                                refetchNotes={refetchNotes} 
                                accessToken={accessToken} 
                                LeadId={booking.LeadACVLRecordID} 
                                userDetails={userDetails} 
                                updateLeadData={updateLeadData}
                                rowId={booking.ROWID} 
                                />}
        </div>
        <div className="status-section">
        <div
          className="lead-section-header"
          onClick={toggleCost}
          style={{
            cursor: "pointer",
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <h2 className="lead-section-title" style={{ margin: 0 }}>
            {moveType === "local" ? "Local Distance Move Cost Calculator" : "Long Distance Move Cost Calculator"}
          </h2>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleMoveType();
              }}
              style={{
                padding: "4px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                cursor: "pointer",
                background: "#fff",
                fontSize: "14px"
              }}
            >
              {moveType === "local" ? "Switch to Long Move" : "Switch to Local Move"}
            </button>
          </div>
        </div>

        {isCostExpanded && (
          <>
            {moveType === "local" ? (
              <MoveCostCalculator
                booking={booking}
                updateBooking={updateBooking}
                accessToken={accessToken}
                userMap={userMap}
                userDetails={userDetails}
              />
            ) : (
              <LongMoveCostCalculator
                booking={booking}
                updateBooking={updateBooking}
                accessToken={accessToken}
                userMap={userMap}
                userDetails={userDetails}
              />
            )}
          </>
        )}
        </div>

        <div className="status-section">
          <div className="lead-section-header" onClick={toggleCall} style={{ cursor: "pointer",marginTop:"10px" }}>
            <h2 className="lead-section-title">
              Call Script - Terms & Conditions
              <button onClick={(e) => { e.stopPropagation(); toggleCall(); }}></button>
            </h2>
          </div>
          {isCallExpanded && (
            <CallScript accessToken={accessToken} />
          )}
        </div>


      </div>
    </div>
  );
};
const Section = ({ title, fields, booking, accessToken, userMap, userDetails, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const isLeadInfoSection = title === "Lead Information";
  const hasDuplicateDetails = booking && booking.Duplicate_Lead_Details && booking.Duplicate_Lead_Details.trim() !== "";
  const isReturnStatus = booking && booking.Lead_Source_Status === "Return";

  let updatedFields = [...fields];

  if (isLeadInfoSection) {
    const returnFields = [
      { label: "Return Category", key: "Return_Category" },
      { label: "Return Outcome", key: "Return_Outcome" },
      { label: "Return Reason Provide", key: "Return_Reason_Provide" },
      { label: "Return Outcome Reason", key: "Return_Outcome_Reason" },
    ];

    const leadSourceStatusIndex = fields.findIndex(field => field.key === "Lead_Source_Status");

    updatedFields.push({ label: "Duplicate Lead Details", key: "Duplicate_Lead_Details" });

    if (isReturnStatus && leadSourceStatusIndex !== -1) {
      updatedFields.splice(leadSourceStatusIndex + 2, 0, ...returnFields);
    }
  }

  const headerStyle = {
    cursor: "pointer",
    background: isLeadInfoSection && hasDuplicateDetails ? "#FF0000" : "#4169E1",
    padding: "15px 20px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    animation: "EstimateFadeIn 0.5s ease-in-out",
    height: "60px",
  };

  const getHrStyle = (key) => {
    if (key === "Lead_Source_Status") {
      return { margin: "62px 0px 10px 0", width: "110%", background: "black" };
    } else if (key === "Duplicate_Lead_Details") {
      return { margin: "19.5px 0", width: "100%", background: "black" };
    }
    return {};
  };

  return (
    <div className="lead-section">
      <div className="lead-section-header" style={headerStyle} onClick={toggleExpand}>
        <h2 className="lead-section-title">
          {title}
          <button onClick={(e) => { e.stopPropagation(); toggleExpand(); }}></button>
        </h2>
      </div>
      {isExpanded && (
        <div className="lead-section-content">
          {updatedFields.map((field, index) => {
            if (field.isPlaceholder) {
              return <div key={index} style={{ visibility: "hidden" }}></div>;
            }

            const shouldShowHr = isLeadInfoSection && isReturnStatus &&
              (field.key === "Lead_Source_Status" || field.key === "Duplicate_Lead_Details");

            return (
              <div key={index}>
                <EditableField
                  label={field.label}
                  value={booking[field.key]}
                  rowId={booking.ROWID}
                  fieldKey={field.key}
                  accessToken={accessToken}
                  userMap={userMap}
                  userDetails={userDetails}
                  booking={booking}
                  updateBooking={updateBooking}
                  moveFromMoveToOptions={moveFromMoveToOptions}
                  moveSizeOptions={moveSizeOptions}
                />
                {shouldShowHr && <hr style={getHrStyle(field.key)} />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const EditableField = ({ label, value, rowId, fieldKey, accessToken, userMap, userDetails, booking, updateBooking, moveFromMoveToOptions, moveSizeOptions }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);
  const [tempValue, setTempValue] = useState(value);
  const [showEditIcon, setShowEditIcon] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  const [returnFields, setReturnFields] = useState({
    Return_Category: booking.Return_Category || "",
    Return_Reason_Provide: booking.Return_Reason_Provide || "",
    Return_Outcome: booking.Return_Outcome || "",
    Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
  });

  const returnCategoryOptions = [
    "Returned - Already Moved",
    "Returned - Duplicate",
    "Returned - Invalid",
    "Returned - Need only Estimate",
    "Returned - No Budget",
    "Returned - Test Lead",
    "Returned - Wrong Number",
  ];

  const returnOutcomeOptions = [
    "Approved",
    "Rejected",
  ];

  useEffect(() => {
    setCurrentValue(value);
    setTempValue(value || "");
    setIsEditing(false);
    setErrorMessage("");
    setShowDropdown(false);
    setFilteredOptions(fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions);
    setHighlightedIndex(-1);
    setReturnFields({
      Return_Category: booking.Return_Category || "",
      Return_Reason_Provide: booking.Return_Reason_Provide || "",
      Return_Outcome: booking.Return_Outcome || "",
      Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
    });
  }, [value, booking, moveFromMoveToOptions, moveSizeOptions, fieldKey]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
        setHighlightedIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const nonEditableFields = [
    "LeadACVLRecordID",
    "Received_Time_IST",
    "Received_Date_EST",
    "Banner",
    "LeadProviderLeadId",
    "Lead_Status",
    // "Lead_Source",
    "Lead_Priority",
    "Duplicate",
    "Duplicate_Lead_Details",
  ];
  const isReadOnly = nonEditableFields.includes(fieldKey);

  // const userOptions = Object.entries(userMap).map(([userId, userName]) => ({
  //   id: userId,
  //   name: userName,
  // }));
  // Filter out users with blank pseudoname (assuming userMap maps userId to userName/pseudoname)
  const userOptions = Object.entries(userMap)
    .filter(([userId, userName]) => userName && userName.trim() !== "")
    .map(([userId, userName]) => ({
      id: userId,
      name: userName,
    }));

  const validateCityFormat = (input) => {
    const cityFormatRegex = /^[A-Za-z\s\-.']+,\s[A-Z]{2}$/;
    return cityFormatRegex.test(input);
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    setTempValue(input);
    setErrorMessage("");

    if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
      const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
      if (input.trim() === "") {
        setFilteredOptions(options);
        setShowDropdown(true);
      } else {
        const filtered = options.filter(option =>
          option.toLowerCase().startsWith(input.toLowerCase())
        );
        setFilteredOptions(filtered);
        setShowDropdown(true);
      }
      setHighlightedIndex(-1);
    }
  };

  const handleOptionSelect = (option) => {
    setTempValue(option);
    setShowDropdown(false);
    setHighlightedIndex(-1);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleInputFocus = () => {
    if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
      setShowDropdown(true);
      const options = fieldKey === "Move_Size" ? moveSizeOptions : moveFromMoveToOptions;
      setFilteredOptions(tempValue ? options.filter(option =>
        option.toLowerCase().startsWith(tempValue.toLowerCase())
      ) : options);
    }
  };

  const handleKeyDown = (e) => {
    if (!["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey) || !showDropdown) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(prev => (prev > 0 ? prev - 1 : filteredOptions.length - 1));
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      e.preventDefault();
      handleOptionSelect(filteredOptions[highlightedIndex]);
    } else if (e.key === "Escape") {
      setShowDropdown(false);
      setHighlightedIndex(-1);
    }
  };

  const handleSave = async () => {
    if (isReadOnly) return;

    // Validate city format for OriginCity and DestinationCity
    if (["OriginCity", "DestinationCity"].includes(fieldKey) && tempValue && !validateCityFormat(tempValue)) {
      setErrorMessage("Please enter the city in the format 'City name, XX' (e.g., 'Toronto, ON')");
      return;
    }

    // Validate Move_Size (only check for non-empty)
    if (fieldKey === "Move_Size" && !tempValue.trim()) {
      setErrorMessage("Please enter a move size");
      return;
    }

    const previousBooking = { ...booking };
    let updatedData = [{ ROWID: rowId, [fieldKey]: tempValue }];
    let additionalFields = {};

    if (fieldKey === "AssignedUserID") {
      const selectedUser = userOptions.find((user) => user.id === tempValue);
      if (selectedUser) {
        updatedData[0].Sales_Agent = selectedUser.name;
        additionalFields.Sales_Agent = selectedUser.name;
      }
    } else if (fieldKey === "Lead_Source_Status" && tempValue === "Return") {
      updatedData[0] = {
        ...updatedData[0],
        Return_Category: returnFields.Return_Category,
        Return_Reason_Provide: returnFields.Return_Reason_Provide,
        Return_Outcome: returnFields.Return_Outcome,
        Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
      };
      additionalFields = {
        ...additionalFields,
        Return_Category: returnFields.Return_Category,
        Return_Reason_Provide: returnFields.Return_Reason_Provide,
        Return_Outcome: returnFields.Return_Outcome,
        Return_Outcome_Reason: returnFields.Return_Outcome_Reason,
      };
    } else if (fieldKey === "Lead_Source_Status" && tempValue === "Valid") {
      updatedData[0] = {
        ...updatedData[0],
        Return_Category: "",
        Return_Reason_Provide: "",
        Return_Outcome: "",
        Return_Outcome_Reason: "",
      };
      additionalFields = {
        ...additionalFields,
        Return_Category: "",
        Return_Reason_Provide: "",
        Return_Outcome: "",
        Return_Outcome_Reason: "",
      };
    } else if (["Return_Category", "Return_Reason_Provide", "Return_Outcome", "Return_Outcome_Reason"].includes(fieldKey)) {
      updatedData[0] = {
        ...updatedData[0],
        [fieldKey]: tempValue,
      };
      additionalFields = {
        ...additionalFields,
        [fieldKey]: tempValue,
      };
    } else {
      if (!booking.AssignedUserID) {
        updatedData[0].AssignedUserID = userDetails.userId;
        const defaultUser = userOptions.find((user) => user.id === userDetails.userId);
        if (defaultUser) {
          updatedData[0].Sales_Agent = defaultUser.name;
          additionalFields.AssignedUserID = userDetails.userId;
          additionalFields.Sales_Agent = defaultUser.name;
        }
      }
    }
    console.log (updatedData);
    try {
      updateBooking(fieldKey, tempValue, additionalFields);
      const response = await fetch("https://salesjet-10097049716.development.catalystappsail.com/leadsdata", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      // console.log("Save successful, updated booking:", booking);
      setCurrentValue(tempValue);
      setIsEditing(false);
      setErrorMessage("");
      setShowDropdown(false);
    } catch (error) {
      console.error("Error updating field", error);
      updateBooking(fieldKey, previousBooking[fieldKey], {
        Sales_Agent: previousBooking.Sales_Agent,
        AssignedUserID: previousBooking.AssignedUserID,
        Return_Category: previousBooking.Return_Category,
        Return_Reason_Provide: previousBooking.Return_Reason_Provide,
        Return_Outcome: previousBooking.Return_Outcome,
        Return_Outcome_Reason: previousBooking.Return_Outcome_Reason,
      });
      setTempValue(currentValue);
      setReturnFields({
        Return_Category: previousBooking.Return_Category || "",
        Return_Reason_Provide: previousBooking.Return_Reason_Provide || "",
        Return_Outcome: previousBooking.Return_Outcome || "",
        Return_Outcome_Reason: previousBooking.Return_Outcome_Reason || "",
      });
      setErrorMessage("Failed to save changes. Please try again.");
    }
  };

  const handleCancel = () => {
    setTempValue(currentValue);
    setReturnFields({
      Return_Category: booking.Return_Category || "",
      Return_Reason_Provide: booking.Return_Reason_Provide || "",
      Return_Outcome: booking.Return_Outcome || "",
      Return_Outcome_Reason: booking.Return_Outcome_Reason || "",
    });
    setIsEditing(false);
    setErrorMessage("");
    setShowDropdown(false);
    setHighlightedIndex(-1);
  };

  const handleInputClick = () => {
    if (!isReadOnly) {
      setIsEditing(true);
      setShowDropdown(["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey));
    }
  };

  if (["OriginCity", "DestinationCity", "Move_Size"].includes(fieldKey)) {
    // console.log(`Rendering ${fieldKey} with tempValue:`, tempValue);
    // console.log(`Rendering ${fieldKey} with moveFromMoveToOptions:`, moveFromMoveToOptions);
    // console.log(`Rendering ${fieldKey} with moveSizeOptions:`, moveSizeOptions);
    // console.log(`Rendering ${fieldKey} with filteredOptions:`, filteredOptions);
  }

  return (
    <div className="editable-field" onMouseEnter={() => setShowEditIcon(true)} onMouseLeave={() => setShowEditIcon(false)}>
      <label>{label}</label>
      {errorMessage && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
          {errorMessage}
        </div>
      )}
      <div className="input-container" style={{ display: "flex", alignItems: "center" }}>
        {fieldKey === "AssignedUserID" ? (
          isEditing ? (
            <select value={tempValue || ""} onChange={e => setTempValue(e.target.value)} className="editable-input" style={{ width: "100%", padding: "8px" }}>
              <option value="">Select User</option>
              {userOptions.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={userMap[currentValue] || "Select User"}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "Move_Date"  || fieldKey === "DeliveryDate" ? (
          isEditing ? (
            <input
              type="date"
              style={{ width: "80%", padding: "8px" }}
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              autoFocus
            />
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "Duplicate_Lead_Details" ? (
          <textarea
            value={tempValue || ""}
            readOnly
            className="read-only-input"
            style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
          />
        ) : fieldKey === "Return_Reason_Provide" || fieldKey === "Return_Outcome_Reason" 
        || fieldKey === "ToolsRequired" || fieldKey === "PackingSupplies" || fieldKey === "Inventory_List" || fieldKey === "Customer_Instructions" ? (
          isEditing ? (
            <textarea
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
            />
          ) : (
            <textarea
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "98.5%", minHeight: "70px", resize: "vertical", padding: "8px" }}
            />
          )
        ) : fieldKey === "Return_Category" ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Return Category</option>
              {returnCategoryOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "Lead_Source_Status" ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Status</option>
              <option value="Valid">Valid</option>
              <option value="Return">Return</option>
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "OriginPropertyType" || fieldKey === "DestinationPropertyType" ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Status</option>
              <option value="Apartment">Apartment</option>
              <option value="Condo">Condo</option>
              <option value="Townhouse">Townhouse</option>
              <option value="House">House</option>
              <option value="Storage">Storage</option>
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ): fieldKey === "Return_Outcome" ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Return Outcome</option>
              {returnOutcomeOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ): fieldKey === "FlexibleDeliveryDate" || fieldKey === "NeedPackingServices"
        || fieldKey === "ParkingAvailableAtOrigin" || fieldKey === "HeavyEquipments"
        || fieldKey === "ParkingAvailableAtDestination" || fieldKey === "ServiceElevatoratOrigin"
        || fieldKey === "ServiceElevatoratDestination" ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Option</option>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ): fieldKey === "DismantlingOfFurnitures"  ? (
          isEditing ? (
            <select
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            >
              <option value="">Select Option</option>
              <option value="Required">Required</option>
              <option value="Not required">Not required</option>
            </select>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "LongWalkAtDestination" || fieldKey === "LongWalkAtOrigin"  ? (
          isEditing ? (
            <input
              type="number"
              value={tempValue || ""}
              placeholder="Long walks in Yaurds"
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          ) : (
            <input
              type="number"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "NoOfStaircasesAtDestination" || fieldKey === "NoOfStaircasesAtOrigin" ? (
          isEditing ? (
            <input
              type="number"
              value={tempValue || ""}
              placeholder="Enter the count of staircases"
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          ) : (
            <input
              type="number"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : fieldKey === "OriginCity" || fieldKey === "DestinationCity" || fieldKey === "Move_Size" ? (
          isEditing ? (
            <div style={{ position: "relative", width: "100%" }}>
              <input
                type="text"
                ref={inputRef}
                value={tempValue || ""}
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                onKeyDown={handleKeyDown}
                className="editable-input"
                style={{ width: "100%", padding: "8px", minHeight: "34px" }}
                placeholder={fieldKey === "Move_Size" ? "Enter or select move size (e.g., 2 Bedroom)" : "Enter or select city (e.g., Toronto, ON)"}
                autoFocus
              />
              {showDropdown && filteredOptions.length > 0 && (
                <ul
                  ref={dropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    maxHeight: "200px",
                    overflowY: "auto",
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    zIndex: 1000,
                  }}
                >
                  {filteredOptions.map((option, index) => (
                    <li
                      key={option}
                      onClick={() => handleOptionSelect(option)}
                      onMouseEnter={() => setHighlightedIndex(index)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        background: highlightedIndex === index ? "#f0f0f0" : "transparent",
                      }}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
            />
          )
        ) : (
          isEditing ? (
            <input
              type="text"
              value={tempValue || ""}
              onChange={e => setTempValue(e.target.value)}
              className="editable-input"
              style={{ width: "100%", padding: "8px" }}
              autoFocus
            />
          ) : (
            <input
              type="text"
              value={tempValue || ""}
              readOnly
              onClick={handleInputClick}
              className={isReadOnly ? "read-only-input" : "editable-input"}
              style={{ width: "100%", padding: "8px" }}
            />
          )
        )}
        {!isReadOnly && isEditing ? (
          <div className="edit-icons" style={{ marginLeft: "10px" }}>
            <FaCheck onClick={handleSave} className="save-icon" />
            <FaTimes onClick={handleCancel} className="cancel-icon" />
          </div>
        ) : (
          !isReadOnly && showEditIcon && <FaPen className="edit-icon" onClick={() => setIsEditing(true)} style={{ marginLeft: "10px" }} />
        )}
      </div>
    </div>
  );
};

const sections = [
  {
    title: "Lead Information",
    fields: [
      { label: "Sales Agent", key: "AssignedUserID" },
      // { label: "Move Type", key: "Move_Type" },
      { label: "ACVL LeadID", key: "LeadACVLRecordID" },
      { label: "Received Date IST", key: "Received_Time_IST" },
      { label: "Received Date EST", key: "Received_Date_EST" },
      { label: "Banner", key: "Banner" },
      { label: "Lead Priority", key: "Lead_Priority" },
      // { label: "Lead Source ID", key: "LeadProviderLeadId" },
      { label: "Lead Source Status", key: "Lead_Source_Status" },
    ],
  },
  {
    title: "Customer Information",
    fields: [
      { label: "Customer Name", key: "Customer_Name" },
      { label: "Phone Number", key: "Phone_Number" },
      { label: "Alternate Phone Number", key: "Alt_Phone_Number" },
      { label: "Email", key: "Email" },
    ],
  },
  {
    title: "Move Details",
    fields: [
      { label: "Move Size", key: "Move_Size" },
      { label: "Move Type", key: "Move_Type" },
      { label: "Move Date", key: "Move_Date" },
      { label: "Delivery Date", key: "DeliveryDate" },
      { label: "Flexible for Delivery Date", key: "FlexibleDeliveryDate" },
      { label: "From Province", key: "OriginCity" },
      { label: "To Province", key: "DestinationCity" },
      { label: "From Address", key: "FromAddress" },
      { label: "To Address", key: "ToAddress" },
      { label: "From PostCode", key: "FromPostCode" },
      { label: "To PostCode", key: "ToPostCode" },
      { label: "Origin property type", key: "OriginPropertyType" },
      { label: "Destination property type", key: "DestinationPropertyType" },
      { label: "No of staircases at origin", key: "NoOfStaircasesAtOrigin" }, 
      { label: "No of staircases at destination", key: "NoOfStaircasesAtDestination" }, 
      { label: "Which floor at origin", key: "WithFloorAtOrigin" }, 
      { label: "Which floor at destination", key: "WithFloorAtDestination" }, 
      { label: "Elevator availability at origin", key: "ServiceElevatoratOrigin" },
      { label: "Elevator availability at destination", key: "ServiceElevatoratDestination" },
      { label: "Long walk at origin", key: "LongWalkAtOrigin" },
      { label: "Long walk at destination", key: "LongWalkAtDestination" },
      { label: "Parking available at origin", key: "ParkingAvailableAtOrigin" },
      { label: "Parking available at destination", key: "ParkingAvailableAtDestination" },
      { label: "Heavy equipments", key: "HeavyEquipments" },
      { label: "Need packing services", key: "NeedPackingServices" }, 
      { label: "Dismantling of furnitures", key: "DismantlingOfFurnitures" },
      { label: "Tools required to complete the Move", key: "ToolsRequired" }, 
      { label: "Packing supplies", key: "PackingSupplies" }, 
      { label: "Customer Instructions", key: "Customer_Instructions" },
      { label: "Inventory List", key: "Inventory_List" }, 
    ],
  },
];

export default LeadDetails;